import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
// import profile01 from "../../../../../images/profile/1.jpg";
import { Link, useLocation } from "react-router-dom";
import { Form, FormGroup, Label, Input } from "reactstrap";
// import PageTitle from "../../../../layouts/PageTitle";
// import profile02 from "../../../../images/profile/2.jpg";
// import profile03 from "../../../../images/profile/3.jpg";
// import profile04 from "../../../../images/profile/4.jpg";
// import profile05 from "../../../../images/profile/5.jpg";
// import profile06 from "../../../../images/profile/6.jpg";
// import profile07 from "../../../../images/profile/7.jpg";
// import profile08 from "../../../../images/profile/8.jpg";
// import profile09 from "../../../../images/profile/9.jpg";
// import profile from "../../../../images/profile/profile.png";
import Select from "react-select";
import { SRLWrapper } from "simple-react-lightbox";
import {
  Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  // Container,
  ListGroup,
  Dropdown,
  Tab,
} from "react-bootstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Switch from "@material-ui/core/Switch";
import OrderDetailsBlog from "../OrderDetailsBlog";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Typography from "@material-ui/core/Typography";
import OrderDetailsForm from "../OrderDetailsForm";
import KotForm from "../KotForm";
import DeliveryForm from "../DeliveryForm";
import { getDate } from "date-fns";
// import food10 from ".././../../../../images/foods/food10.jpg";
import calendarlogo from ".././../../../../images/foods/calendarlogo2.png";
import headerimage from ".././../../../../images/foods/menu-header-bg.png";
import footerimage from ".././../../../../images/foods/menu-footer-bg.png";
import food25 from ".././../../../../images/foods/food25.jpg";
// import food2 from ".././../../../../images/foods/food2.jpg";

import food2 from ".././../../../../images/foods/food2.jpg";
import food4 from ".././../../../../images/foods/food4.jpg";
import food10 from ".././../../../../images/foods/food10.png";
import food9 from ".././../../../../images/foods/food9.png";
import { TagsInput } from "react-tag-input-component";

import { FIS_BACKEND } from "../../../../../apiservicescall/default";
import { authHeader } from "../../../../../apiservicescall/authHeader";

// import Box from "@mui/material/Box";
// import Container from "@mui/material/Container";

import {
  getCompanyListMaster,
  GetOutletTimingList,
  MenuList,
  saveofMenuAVL,
  saveslotmaster,
  deleteodmenuAVL,
  updateslotmaster,
  getMenuAvailalbitListApi,
  saveoutletDetails,
  getRoleMaster,
  getoutletListMaster,
  addOutletItem,
  UpdateOutletItem,
  gettstaffListMaster,
  getMenuMasterList,
  saveMainMenuName,
  apiReqOnOffDaySlot,
  updatePWDstaffDetails,
  menuCategoryMasterList,
  submenuCategoryMasterList,
  saveSubMenuName,
  fetchOutletItemCategoryApiReq,
  SlotMasterList,
  updateMenuAvailabilityREQ,
  menuPlanListAPICALL,
  weeekMasterApiCallREQ,
  copyofMenuAVLnext,
  UomList,
  downloadTodaymenuMasterApiCallREQ,
  viewTodaymenuMasterApiCallREQ,
  slotWisedownloadTodaymenuMasterApiCallREQ,
  viewTodaymenuslotwiseCallREQ,
  getresbasedmenumaster,
  getresbasedPopularMenumaster,
  subscriptionPlanId,
} from "../../../../../apiservicescall/api";
import SlotPdf from "./SlotPdf";
import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";
// import { CContainer } from '@coreui/react';
import Board from "./Board";
/* import jsPDF from "jspdf"; */
/* import html2canvas from "html2canvas"; */

// import "./styles.css";

import ImageList from "./imageList";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import EventCalendar from "./EventCalendar";
import jsPDF from "jspdf";
import { Restaurant } from "@material-ui/icons";
import  RctSectionLoader from "../../RctSectionLoader/RctSectionLoader";



const ItemBlog = [
  {
    slotname: "Morning ( 7.00 AM - 11.00 AM )",
    slotMaster: [
      {
        id: 1,
        title: "Idly",
        image: food10,
        price: "30 ",
      },
      {
        id: 2,
        title: "Dosai",
        image: food25,
        price: "30 ",
      },
      {
        id: 3,
        title: "Poori",
        image: food10,
        price: "30 ",
      },

      {
        id: 4,
        title: "Meals",
        image: food2,
        price: "30 ",
      },
    ],
  },

  {
    slotname: "Afternoon ( 12.00 PM - 15.00 PM )",
    slotMaster: [
      {
        id: 1,
        title: "Idly",
        image: food10,
        price: "30 ",
      },
      {
        id: 2,
        title: "Dosai",
        image: food25,
        price: "30 ",
      },
      {
        id: 3,
        title: "Poori",
        image: food10,
        price: "30 ",
      },

      {
        id: 4,
        title: "Meals",
        image: food2,
        price: "30 ",
      },
    ],
  },
];

function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

const formatDate = (date) => {
  return [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
    date.getFullYear(),
  ].join("/");
};

const formatDateYYMMDD = (date) => {
  return [
    date.getFullYear(),
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
  ].join("-");
};

const OutletMenuPlanner = (props) => {
  const [activeToggle, setActiveToggle] = useState("posts");
  const [sendMessage, setSendMessage] = useState(false);
  const [postModal, setPostModal] = useState(false);
  const [cameraModal, setCameraModal] = useState(false);
  const [linkModal, setLinkModal] = useState(false);
  const [replayModal, setReplayModal] = useState(false);
  const [foodToggle, setFoodToggle] = useState(true);

  const [todaymenuPopup, setTodaymenuPopup] = useState(false);
  const [menulistpopup, setMenulistpopup] = useState(false);

  const [selectedMenuType, setSelectedMenuType] = useState("");

  const [admintomanger, setAdmintomanger] = useState(
    JSON.parse(localStorage.getItem("admintomanger"))
  );
  const admintomangerjson = admintomanger && admintomanger.split("-");
  const adminToMangerOutletName =
    admintomangerjson && admintomangerjson[0].trim();
  const adminToMangerOutletCode =
    admintomangerjson && admintomangerjson[1].trim();
  const adminToMangerCompanyCode =
    admintomangerjson && admintomangerjson[2].trim();

  const [popUpPageShow, setPopUpPageShow] = useState(false);
  const [subPopUpPageShow, setSubPopUpPageShow] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [togglemodal, setTogglemodal] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const [completed, setCompleted] = useState(new Set());
  const [skipped, setSkipped] = useState(new Set());

  const [selectedOutlet, setSelectedOutlet] = useState(
    JSON.parse(localStorage.getItem("selectedOutlet"))
  );

  const [loginDetails, setLoginDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  const [subPlanId, setSubPlanId] = useState([]);
  const [selectedplanId, setSelectedplanId] = useState({
    label: "",
    value: "",
  });

  const [popularmenu, setPopularMenu] = useState([]);
  const [selectedPopularMenu, setSelectedPopularMenu] = useState([
    { label: "", value: "" },
  ]);

  const [time, setTime] = useState([
    { label: "15Mins", value: "15Mins" },
    { label: "10Mins", value: "10Mins" },
    { label: "25Mins", value: "25Mins" },
    { label: "45Mins", value: "45Mins" },
  ]);

  const [tips, setTips] = useState([
    { label: "Add extra toppings", value: "Add extra toppings" },
    { label: "Add extra cheese", value: "Add extra cheese" },
    { label: "one scoope", value: "one scoope" },
    { label: "No", value: "No" },
  ]);

  const [packing, setPacking] = useState([
    { label: "Leaf", value: "Leaf" },
    { label: "Food Box", value: "Food Box" },
    { label: "Food Sheet", value: "Food Sheet" },
  ]);

  const [location, setLocation] = useState([
    { label: "Outlet", value: "Outlet" },
    { label: "Pick up point1", value: "Pick up point1" },
    { label: "Pick up point2", value: "Pick up point2" },
  ]);

  const [reject, setReject] = useState([
    { label: "Out of stock", value: "Out of stock" },
    { label: "Out of location", value: "Out of location" },
    { label: "Unable to deliver", value: "Unable to deliver" },
    { label: "Kitchen not available", value: "Kitchen not available" },
  ]);

  const [timeslot, setTimeslot] = useState([
    { label: "OutLet Time 06AM-10PM", value: "Outlet Time" },
    { label: "Slot Time", value: "Slot Time" },
  ]);

  const [selected, setSelected] = useState([]);

  const [foodmenu, setFoodmenu] = useState([
    {
      fooditem: "Masala dosa",
      price: "RS.30",
      status: true,
    },
    {
      fooditem: "Idly",
      price: "RS.50",
      status: true,
    },
    {
      fooditem: "Poori",
      price: "RS.70",
      status: true,
    },
    {
      fooditem: "Pongal",
      price: "RS.90",
      status: true,
    },
  ]);
  const [afternnonmenu, setAfternnoonmenu] = useState([
    {
      fooditem: "Masala dosa",
      price: "RS.30",
      status: true,
    },
    {
      fooditem: "Idly",
      price: "RS.50",
      status: true,
    },

    {
      fooditem: "Pongal",
      price: "RS.90",
      status: true,
    },
  ]);
  const [tempselecteuser, setTempselecteuser] = useState({});

  const [content, setContent] = useState([
    {
      slotname: "Morning ( 7.00 AM - 11.00 AM )",
      slotactiveStatus: true,

      slotMaster: [
        {
          id: 1,
          title: "Idly",
          image: food10,
          activeStatus: false,
          price: "30.00",
          category: "BreakFast",
          subcategory: "Idly Varities",
        },
        {
          id: 2,
          title: "Dosai",
          image: food25,
          activeStatus: true,
          price: "30.00",
          category: "BreakFast",
          subcategory: "Idly Varities",
        },
        {
          id: 3,
          title: "Poori",
          image: food10,
          activeStatus: true,
          price: "30.00",
          category: "BreakFast",
          subcategory: "Idly Varities",
        },
        {
          id: 4,
          title: "Meals",
          image: food2,
          activeStatus: true,
          price: "30.00",
          category: "BreakFast",
          subcategory: "Idly Varities",
        },
      ],
    },
    {
      slotname: "Afternoon ( 12.00 PM - 15.00 PM )",
      slotactiveStatus: false,
      slotMaster: [
        {
          id: 1,
          title: "Idly",
          image: food10,
          activeStatus: true,
          price: "30.00",
          category: "BreakFast",
          subcategory: "Idly Varities",
        },
        {
          id: 2,
          title: "Dosai",
          image: food25,
          activeStatus: true,
          price: "30.00",
          category: "BreakFast",
          subcategory: "Idly Varities",
        },
        {
          id: 3,
          title: "Poori",
          image: food10,
          activeStatus: true,
          price: "30.00",
          category: "BreakFast",
          subcategory: "Idly Varities",
        },

        {
          id: 4,
          title: "Meals",
          image: food2,
          activeStatus: true,
          price: "30.00",
          category: "BreakFast",
          subcategory: "Idly Varities",
        },
      ],
    },
  ]);

  const [testsc, setTestsc] = useState([
    {
      value: "Idly",
      label: (
        <div>
          <img src={food2} height="30px" width="30px" /> Idly - Breakfast - Idly
          Varities{" "}
        </div>
      ),
    },
    {
      value: "Dosai",
      label: (
        <div>
          <img src={food25} height="30px" width="30px" /> Dosai - Breakfast -
          Idly Varities{" "}
        </div>
      ),
    },
    {
      value: "Poori",
      label: (
        <div>
          <img src={food2} height="30px" width="30px" /> Poori - Breakfast -
          Idly Varities{" "}
        </div>
      ),
    },
    {
      value: "Meals",
      label: (
        <div>
          <img src={food25} height="30px" width="30px" /> Meals - Lunch - Meals
          Varities{" "}
        </div>
      ),
    },
  ]);
  const [menufetchitem, setMenufetchitem] = useState([]);

  const [categoryMaster, setCategoryMaster] = useState([]);
  const [subcategoryMaster, setSubcategoryMaster] = useState([]);

  const [uomcategory, setUomcategory] = useState([]);
  const [selUom, setSelUom] = useState({});
  const [uomlist, setUomlist] = useState([
    {
      uomId: "",
      uomDescription: "",
      status: "",
    },
  ]);

  const [isView, setIsview] = useState(false);
  const [formIsValid, setFormIsValid] = useState(false);
  const [errors, setErrors] = useState({
    itemName: null,
    itemPrice: null,
    itemQuantity: null,
    itemDesc: null,
    itemfamily: null,
    uom: null,
    itemType: null,
  });
  const reportTemplateRef = useRef(null);

  const { state } = useLocation();
  const { selectedDate } = state || "";
  const [isTodayMenu, setIsTodayMenu] = useState(selectedDate ? true : false);

  const [menuAvailablitMaster, setMenuAvailablitMaster] = useState({
    dayId: new Date().getDay(),
    dayName: new Date().toLocaleDateString("en-us", { weekday: "long" }),
    itemFlag: "ON",
    itemImagePath: "",
    outletCode:
      adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode,
    slotFlag: "ON",

    menuId: "",
    mainMenuId: "",
    subMenuId: "",
    slotId: [],
    status: "A",
    todayDate: formatDate(new Date()),
    planId: "",
    planName: "",
  });

  const [dayOnOff, setDayOnOff] = useState(true);

  const [editmenuavailablity, setEditmenuavailablity] = useState(false);

  const [selectedSlotTiming, setSelectedSlotTiming] = useState([
    {
      label: "",
      value: "",
    },
  ]);
  const [slotmaster, setSlotmaster] = useState([]);
  const [menuPlanList, setMenuPlanList] = useState([]);

  const [selectedMenuItem, setSelectedMenuItem] = useState({
    label: "",
    value: "",
  });

  const [selectedcategoryMaster, setSelectedcategoryMaster] = useState({
    label: "",
    value: "",
  });

  const [selectedsubcategoryMaster, setSelectedsubcategoryMaster] = useState({
    label: "",
    value: "",
  });

  const [selectedslotmaster, setSelectedslotmaster] = useState({
    label: "",
    value: "",
  });

  const [selectedDateName, setSelectedDateName] = useState("");
  const [selectedDateFormat, setSelectedDateFormat] = useState("");
  const [selectedDateID, setSelectedDateID] = useState("");
  const dateschec = new Date();
  let tempdateschec = dateschec.setDate(new Date().getDate() + 1);
  let endofweek = dateschec.setDate(new Date().getDate() + 6);
  const tomorrowId = formatDate(new Date(tempdateschec));
  const tomorrowName = new Date(tempdateschec).toLocaleDateString("en-us", {
    weekday: "long",
  });

  const [board, setBoard] = useState([
    {
      id: 1,
      name: "ORDERS",
      items: [
        { id: 41, name: "orderIdNo1" },
        { id: 42, name: "orderIdNo2" },
        { id: 43, name: "orderIdNo3" },
        { id: 44, name: "orderIdNo4" },
        { id: 45, name: "orderIdNo5" },
        { id: 46, name: "orderIdNo6" },
        { id: 47, name: "orderIdNo7" },
        { id: 48, name: "orderIdNo8" },
        { id: 49, name: "orderIdNo9" },
      ],
    },
    {
      id: 2,
      name: "KITCHEN",
      items: [],
    },
    {
      id: 3,
      name: "DELIVERY",
      items: [],
    },
  ]);
  const [menulistitem, setMenulistitem] = useState([
    {
      compCode: userDetails,
      itemDesc: "",
      itemFoodImage: "",
      itemImagePath: "",
      itemId: "",
      itemName: "",
      itemPrice: "",
      itemQuantity: "",
      itemType: true,
      itemTag: "",
      outletCode: userDetails,
      status: "",
      uom: "",
      planId: "",
      planName: "",
      varient: [
        {
          varientType: "",
          small: "",
          medium: "",
          large: "",
        },
      ],
    },
  ]);
  const [selecteduomMaster, setSelecteduomMaster] = useState({
    label: "",
    value: "",
  });
  const [weeklymenu, setWeeklymenu] = useState([
    {
      outletDate: "19/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Wednesday",
      status: "A",
      slotOfDay: [
        {
          slotId: "1",
          slotName: "Lunch Wd",
          slotFlag: "ON",
          slotStartTime: "06:0:00",
          slotEndTime: "10:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Dry Fruit Kaju Mothi Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Kaju Mothi Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
        {
          slotId: "2",
          slotName: "Breakfast wd",
          slotFlag: "ON",
          slotStartTime: "16:0:00",
          slotEndTime: "18:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Mysore Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
        {
          slotId: "3",
          slotName: "dinner wd",
          slotFlag: "ON",
          slotStartTime: "16:0:00",
          slotEndTime: "18:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Mysore Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
      ],
    },
    {
      outletDate: "20/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Thrusday",
      status: "A",
      slotOfDay: [
        // {
        //   "slotId": "2",
        //   "slotName": "Breakfast Thrusday",
        //   "slotFlag": "ON",
        //   "slotStartTime": "06:0:00",
        //   "slotEndTime": "10:0:00",
        //   "categorySubCategoryList": [
        //     {
        //       "mainMenuId": "1005",
        //       "mainMenuName": "Sweet",
        //       "subMenuId": "2005",
        //       "subMenuName": "Cold Sweets",
        //       "menuId": "3001",
        //       "menuName": "Kaju Pak",
        //       "status": "A",
        //       "itemFlag": "ON",
        //       "itemPath": "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
        //       "price": "12.00",
        //       "quantity": "12"
        //     },
        //     {
        //       "mainMenuId": "1005",
        //       "mainMenuName": "Sweet",
        //       "subMenuId": "2005",
        //       "subMenuName": "Cold Sweets",
        //       "menuId": "3001",
        //       "menuName": "Laddu",
        //       "status": "A",
        //       "itemFlag": "ON",
        //       "itemPath": "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
        //       "price": "12.00",
        //       "quantity": "12"
        //     },
        //     {
        //       "mainMenuId": "1005",
        //       "mainMenuName": "Sweet",
        //       "subMenuId": "2005",
        //       "subMenuName": "Cold Sweets",
        //       "menuId": "3001",
        //       "menuName": "Laddu",
        //       "status": "A",
        //       "itemFlag": "ON",
        //       "itemPath": "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
        //       "price": "12.00",
        //       "quantity": "12"
        //     },
        //     {
        //       "mainMenuId": "1005",
        //       "mainMenuName": "Sweet",
        //       "subMenuId": "2005",
        //       "subMenuName": "Cold Sweets",
        //       "menuId": "3001",
        //       "menuName": "Laddu",
        //       "status": "A",
        //       "itemFlag": "ON",
        //       "itemPath": "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
        //       "price": "12.00",
        //       "quantity": "12"
        //     }
        //   ]
        // },
        // {
        //   "slotId": "2",
        //   "slotName": "Lunch Thrusday",
        //   "slotFlag": "ON",
        //   "slotStartTime": "16:0:00",
        //   "slotEndTime": "18:0:00",
        //   "categorySubCategoryList": [
        //     {
        //       "mainMenuId": "1005",
        //       "mainMenuName": "Sweet",
        //       "subMenuId": "2005",
        //       "subMenuName": "Cold Sweets",
        //       "menuId": "3001",
        //       "menuName": "Dry halwa",
        //       "status": "A",
        //       "itemFlag": "ON",
        //       "itemPath": "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
        //       "price": "12.00",
        //       "quantity": "12"
        //     }
        //   ]
        // }
      ],
    },
    {
      outletDate: "21/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Friday",
      status: "A",
      slotOfDay: [],
    },
    {
      outletDate: "22/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Saturday",
      status: "A",
      slotOfDay: [],
    },
    {
      outletDate: "23/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Sunday",
      status: "A",
      slotOfDay: [
        {
          slotId: "2",
          slotName: "Breakfast Sunday",
          slotFlag: "ON",
          slotStartTime: "06:0:00",
          slotEndTime: "10:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Kaju Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Laddu",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
        {
          slotId: "2",
          slotName: "Lunch Sunday",
          slotFlag: "ON",
          slotStartTime: "16:0:00",
          slotEndTime: "18:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Dry halwa",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
      ],
    },
    {
      outletDate: "24/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Monday",
      status: "A",
      slotOfDay: [
        {
          slotId: "2",
          slotName: "Breakfast Monday",
          slotFlag: "ON",
          slotStartTime: "06:0:00",
          slotEndTime: "10:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Kaju Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Laddu",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
        {
          slotId: "2",
          slotName: "Lunch Monday",
          slotFlag: "ON",
          slotStartTime: "16:0:00",
          slotEndTime: "18:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Dry halwa",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
      ],
    },
    {
      outletDate: "25/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Tuesday",
      status: "A",
      slotOfDay: [],
    },
  ]);
  const [pastweekmenu, setPastweekmenu] = useState([
    {
      outletDate: "12/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Wednesday",
      status: "A",
      slotOfDay: [
        {
          slotId: "1",
          slotName: "Lunch Wd",
          slotFlag: "ON",
          slotStartTime: "06:0:00",
          slotEndTime: "10:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Dry Fruit Kaju Mothi Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Kaju Mothi Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
        {
          slotId: "2",
          slotName: "Breakfast wd",
          slotFlag: "ON",
          slotStartTime: "16:0:00",
          slotEndTime: "18:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Mysore Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
      ],
    },
    {
      outletDate: "13/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Thrusday",
      status: "A",
      slotOfDay: [
        {
          slotId: "2",
          slotName: "Breakfast Thrusday",
          slotFlag: "ON",
          slotStartTime: "06:0:00",
          slotEndTime: "10:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Kaju Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Laddu",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
        {
          slotId: "2",
          slotName: "Lunch Thrusday",
          slotFlag: "ON",
          slotStartTime: "16:0:00",
          slotEndTime: "18:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Dry halwa",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
      ],
    },
    {
      outletDate: "14/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Friday",
      status: "A",
      slotOfDay: [
        {
          slotId: "2",
          slotName: "Breakfast Friday",
          slotFlag: "ON",
          slotStartTime: "06:0:00",
          slotEndTime: "10:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Kaju Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Laddu",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
        {
          slotId: "2",
          slotName: "Lunch Friday",
          slotFlag: "ON",
          slotStartTime: "16:0:00",
          slotEndTime: "18:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Dry halwa",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
      ],
    },
    {
      outletDate: "15/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Saturday",
      status: "A",
      slotOfDay: [
        {
          slotId: "2",
          slotName: "Breakfast Sat",
          slotFlag: "ON",
          slotStartTime: "06:0:00",
          slotEndTime: "10:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Kaju Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Laddu",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
        {
          slotId: "2",
          slotName: "Lunch Sat",
          slotFlag: "ON",
          slotStartTime: "16:0:00",
          slotEndTime: "18:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Dry halwa",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
      ],
    },
    {
      outletDate: "16/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Sunday",
      status: "A",
      slotOfDay: [
        {
          slotId: "2",
          slotName: "Breakfast Sunday",
          slotFlag: "ON",
          slotStartTime: "06:0:00",
          slotEndTime: "10:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Kaju Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Laddu",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
        {
          slotId: "2",
          slotName: "Lunch Sunday",
          slotFlag: "ON",
          slotStartTime: "16:0:00",
          slotEndTime: "18:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Dry halwa",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
      ],
    },
    {
      outletDate: "17/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Monday",
      status: "A",
      slotOfDay: [],
    },
    {
      outletDate: "18/12/2022",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Tuesday",
      status: "A",
      slotOfDay: [
        {
          slotId: "2",
          slotName: "Breakfast Tues",
          slotFlag: "ON",
          slotStartTime: "06:0:00",
          slotEndTime: "10:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Kaju Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Laddu",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
      ],
    },
  ]);
  const [nextweekmenu, setNextweekmenu] = useState([
    {
      outletDate: "1/1/2023",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Wednesday",
      status: "A",
      slotOfDay: [],
    },
    {
      outletDate: "2/1/2023",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Thrusday",
      status: "A",
      slotOfDay: [],
    },
    {
      outletDate: "3/1/2023",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Friday",
      status: "A",
      slotOfDay: [
        {
          slotId: "2",
          slotName: "Breakfast Friday",
          slotFlag: "ON",
          slotStartTime: "06:0:00",
          slotEndTime: "10:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Kaju Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Laddu",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
        {
          slotId: "2",
          slotName: "Lunch Friday",
          slotFlag: "ON",
          slotStartTime: "16:0:00",
          slotEndTime: "18:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Dry halwa",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
      ],
    },
    {
      outletDate: "4/1/2023",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Saturday",
      status: "A",
      slotOfDay: [],
    },
    {
      outletDate: "5/1/2023",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Sunday",
      status: "A",
      slotOfDay: [],
    },
    {
      outletDate: "6/1/2023",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Monday",
      status: "A",
      slotOfDay: [
        {
          slotId: "2",
          slotName: "Breakfast Monday",
          slotFlag: "ON",
          slotStartTime: "06:0:00",
          slotEndTime: "10:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Kaju Pak",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Laddu",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
        {
          slotId: "2",
          slotName: "Lunch Monday",
          slotFlag: "ON",
          slotStartTime: "16:0:00",
          slotEndTime: "18:0:00",
          categorySubCategoryList: [
            {
              mainMenuId: "1005",
              mainMenuName: "Sweet",
              subMenuId: "2005",
              subMenuName: "Cold Sweets",
              menuId: "3001",
              menuName: "Dry halwa",
              status: "A",
              itemFlag: "ON",
              itemPath:
                "https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100002/3001/1670331250716-download.jpg",
              price: "12.00",
              quantity: "12",
            },
          ],
        },
      ],
    },
    {
      outletDate: "7/1/2023",
      outletCode: "100002",
      outletName: "Ekkatuthangal",
      dayId: "3",
      dayName: "Tuesday",
      status: "A",
      slotOfDay: [],
    },
  ]);
  const [selectedWeekType, setSelectedWeekType] = useState("");
  const [viewmoreslots, setViewmoreslots] = useState(false);
  const [
    viewmoreslotsCardOnclikValidation,
    setviewmoreslotsCardOnclikValidation,
  ] = useState(false);
  const [selectedViewMoreslotsDetails, setSelectedViewMoreslotsDetails] =
    useState();
  const [
    weeklyMenuMasterOfPastCurrentNextWeeks,
    setWeeklyMenuMasterOfPastCurrentNextWeeks,
  ] = useState([]);

  const [priceAmountOfItem, setPriceAmountOfItem] = useState("");
  const [quanitytyOfItem, setQuanitytyOfItem] = useState("");
  const [updatemenuAvailablitymainItem, SetUpdatemenuAvailablitymainItem] =
    useState([]);
  const [updatemenuAvailablitysubItem, SetUpdatemenuAvailablitysubItem] =
    useState([]);
  const [foodTypeFromOutlet, setFoodTypeFromOutlet] = useState("");
  const [arrowRightLeft, setArrowRightLeft] = useState(false);

  const [pdfDataTodaymenu, setPdfDataTodaymenu] = useState([]);

  const [companyMaster, setCompanyMaster] = useState([]);
  const [outletvalue, setOutletvalue] = useState([]);
  const [outletMasterlist, setOutletMasterlist] = useState([]);
  const [restarantvalue, setRestarantvalue] = useState([
    { label: "", value: "", restaurantId: "" },
  ]);
  // const[  SelectRestarantvalue,  setSelectRestarantvalue]=usestate({label: "", value: "",  });

  const [specialmenulist, setSpecialMenu] = useState([]);
  const [selectedspecialMenu, setSelectedSpecialMenu] = useState([
    { label: "", value: "" },
  ]);

  const [loader, setLoader] = useState(false);


  useEffect(() => {
    let outletCode =
      adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
    //  getmenulist(compCode, outletCode);
    // getmainCategoryMaster(outletCode);
    // getslotmaster(outletCode);
    weeekMasterApiCall("currentweek");
    //  menuPlanListREQ(todayformat);
    getuomlist();
    getoutletMasterList();
    getcompanyMasterList();
    
  }, []);

  const getcompanyMasterList = useCallback(async () => {
    let getoutletList = await getCompanyListMaster();
    let getoutletListValue = getoutletList?.data?.data;
    let companyoutmaster = getoutletListValue.map(({ compCode, compName }) => ({
      label: compName,
      value: compCode,
    }));
    setCompanyMaster(companyoutmaster);
    setOutletvalue({
      label: getoutletListValue[0]?.compName,
      value: getoutletListValue[0]?.compCode,
    });
    getoutletMasterList(getoutletListValue[0]?.compCode);
  }, []);

  const getoutletMasterList = async (companyCode) => {
    let getoutletList = await getoutletListMaster(companyCode);
    let getoutletListValue = getoutletList?.data?.data;
    // console.log("getoutletListValue", getoutletListValue);
    let companyoutmaster =
      getoutletListValue &&
      getoutletListValue.map(({ outletCode, outletName, restaurantId }) => ({
        label: `${outletName}`,
        value: outletCode,
        restaurantId: restaurantId,
      }));
    //   console.log("companyoutmaster", companyoutmaster);
    setOutletMasterlist(companyoutmaster);
  };

  //   const getoutletList = async () => {
  //     let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
  //     let getoutletList = await getoutletListMaster(compCode);
  //     let getoutletListValue = getoutletList?.data?.data;
  //     let Outcode = adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode;
  //     let tempstatemaster = getoutletListValue && getoutletListValue.filter((item) => item.outletCode == Outcode).map((items) => ({ items }));
  //     let checkItemVegTypefromOutletChe = tempstatemaster && tempstatemaster[0]?.items?.outletFoodType == "veg,nong-veg" ? "veg,nong-veg" : "veg";
  //     console.log(
  //       "tempstatemaster[0]?.items?.outletFoodType",
  //       tempstatemaster[0]?.items?.outletFoodType
  //     );
  //     console.log("checkItemVegTypefromOutletChe", checkItemVegTypefromOutletChe);
  //     setFoodTypeFromOutlet(checkItemVegTypefromOutletChe);
  //     setMenulistitem({ itemType: true });
  //   };

  const getmenulist = async (compCode, outletCode) => {
   

    // console.log("compCode", compCode);
    // console.log("outletCode", outletCode);

    let getslotList = await fetchOutletItemCategoryApiReq(compCode, outletCode);
    let getslotListValue = getslotList?.data?.data;
    console.log("getslotListValue12131", getslotListValue);
    let outmaster =
      getslotListValue &&
      getslotListValue.map(
        ({
          itemName,
          itemId,
          itemPrice,
          itemImagePath,
          categoryName,
          subCategoryName,
          categoryId,
          subCategoryId,
          itemQuantity,
          uom,
          planName,
          planId,
        }) => ({
          label:
            // <>
            //   <img src={itemImagePath} height="30px" width="30px" />
            //   {itemName}{" "}
            //   - ₹.{itemPrice}.00 - {categoryName} - {subCategoryName}
            // <>
            ` ${itemName} - ₹.${itemPrice}`,
          // value: itemId,
          value: `${itemId} - ${categoryId} - ${subCategoryId} - ${itemPrice} - ${itemQuantity} - ${uom}- ${categoryName} - ${subCategoryName}-${planId}-${planName}`,
        })
      );
    setMenufetchitem(outmaster);

    // console.log("outmaster",outmaster);
    // console.log("fwetch menu",menufetchitem);
  };

  const weeekMasterApiCall = async (selectedweektype) => {
    setSelectedWeekType(selectedweektype);
    // let outletCode =  adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let outletCode = restarantvalue.value;
    let getslotList = await weeekMasterApiCallREQ(outletCode, selectedweektype);
    let getslotListValue = getslotList?.data?.data;
    setWeeklyMenuMasterOfPastCurrentNextWeeks(getslotListValue);
  };

  const getRestarantmenulist = async (event) => {
    let restaurantId = event.restaurantId;
    let getresmenuid = await getresbasedmenumaster(restaurantId);
    // console.log("getresmenuid", getresmenuid);

    let getresmenu = getresmenuid.data.data || [];

    //console.log("getresmenu getresmenu", getresmenu);

    let specialmenulist = getresmenu.map(({ id, name }) => ({
      label: name,
      value: id,
    }));
    setSpecialMenu(specialmenulist);
  };

  const downloadTodaymenuMasterApiCall = async (dayId, outletDate) => {
    //// let outletCode = adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let outletCode = restarantvalue.value;
    let getslotList = await downloadTodaymenuMasterApiCallREQ(
      outletCode,
      dayId,
      outletDate
    );
    if (getslotList.status === 200) {
      // NotificationManager.success("Downloaded");
      const url = window.URL.createObjectURL(new Blob([getslotList.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `MENU_PDF_${outletDate}.pdf`);
      link.click();
      setTimeout(() => window.URL.revokeObjectURL(url), 0);
      //   await this.setState({ reload: false });
    } else {
      //   await this.setState({ reload: false });
      //   NotificationManager.error("error", error?.message);
    }
  };

  const slotWisedownloadTodaymenuMasterApiCall = async (
    todayId,
    slotId,
    outletDate
  ) => {
    let outletCode =
      adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;

    let getslotList = await slotWisedownloadTodaymenuMasterApiCallREQ(
      outletCode,
      todayId,
      slotId,
      outletDate
    );
    if (getslotList.status === 200) {
      // NotificationManager.success("Downloaded");
      const url = window.URL.createObjectURL(new Blob([getslotList.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `MENU_PDF_${outletDate}.pdf`);
      link.click();
      setTimeout(() => window.URL.revokeObjectURL(url), 0);
      //   await this.setState({ reload: false });
    } else {
      //   await this.setState({ reload: false });
      //   NotificationManager.error("error", error?.message);
    }
  };

  const viewTodaymenuMasterApiCall = async (dayId, outletDate) => {
    let outletCode =
      adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let getslotList = await viewTodaymenuMasterApiCallREQ(
      outletCode,
      dayId,
      outletDate
    );
    if (getslotList.status === 200) {
      const file = new Blob([getslotList.data], { type: "application/pdf" });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //Open the URL on new Window
      // console.log("fileURL", fileURL)
      window.open(fileURL);
      // NotificationManager.success("Downloaded");
      // const url = window.URL.createObjectURL(
      //   new Blob([getslotList.data])
      // );
      // const link = document.createElement("a");
      // link.href = url;
      // link.setAttribute("download", `MENU_PDF_${outletDate}.pdf`);
      // link.click();
      // setTimeout(() => window.URL.revokeObjectURL(url), 0);
      //   await this.setState({ reload: false });
    } else {
      //   await this.setState({ reload: false });
      //   NotificationManager.error("error", error?.message);
    }
  };

  const viewTodaymenuSlotwiseApiCall = async (todayId, slotId, outletDate) => {
    let outletCode =
      adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let getslotList = await viewTodaymenuslotwiseCallREQ(
      outletCode,
      todayId,
      slotId,
      outletDate
    );
    if (getslotList.status === 200) {
      const file = new Blob([getslotList.data], { type: "application/pdf" });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } else {
      //   await this.setState({ reload: false });
      //   NotificationManager.error("error", error?.message);
    }
  };

  const setCatSubFromSelectedMenu = async (e) => {
    let outletCode = outletvalue.value;
    //adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let compCode = restarantvalue.value;
    //adminToMangerCompanyCode || loginDetails?.companyCode;
    let getslotList = await MenuList(compCode, outletCode);
    let getslotListValue = getslotList?.data?.data || [];
    // console.log("getfetchlist plan", getslotListValue);
    let outmaster =
      getslotListValue &&
      getslotListValue.find((value, index) => value?.itemId === e);
    // console.log("outmaster123", outmaster);
    // console.log("outmaster123", typeof outmaster);

    // setSelectedcategoryMaster({
    //   label: outmaster?.categoryName || "",
    //   value: outmaster?.categoryId || "",
    // })

    // setSelectedsubcategoryMaster({
    //   label: outmaster?.subCategoryName || "",
    //   value: outmaster?.subCategoryId || "",
    // });
  };

  const menuPlanListREQ = async (selecteddate, restarantmaster) => {
    let outletCode = restarantmaster || restarantvalue.value;
    //    let outletCode =  adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    //     let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
    let todayDate =
      selecteddate == undefined ? selectedDateFormat : selecteddate;
    // console.log("selectedMenuType", selectedMenuType);
    // console.log("setSelectedDateName", selectedDateName);
    // console.log("setSelectedDateFormat", selectedDateFormat);
    // console.log("setSelectedDateFormat", selecteddate);
    let getslotList = await menuPlanListAPICALL(outletCode, todayDate);
    let getslotListValue = getslotList?.data?.data || [];
    setMenuPlanList(getslotListValue);
    // console.log("multinames123", getslotList?.data?.data);
    // console.log(
    //   "multinames1234",
    //   getslotList?.data?.data.some((e) => e.slotFlag === "ON")
    // );
    let multinames =
      getslotList?.data?.data &&
      getslotList?.data?.data.some((e) => e.slotFlag === "ON");
    // console.log("multinames", multinames);
    if (multinames === false) {
      setDayOnOff(false);
    } else {
      setDayOnOff(true);
    }

    /// eye on click to list api changes

    // getslotListValue && getslotListValue.map((items) => {
    //   setSelectedDateName(items.dayName);
    //   setSelectedDateFormat(items.outletDate);
    //   setSelectedDateID(items.dayId);
    // });

    setSelectedViewMoreslotsDetails(getslotListValue);
  };

  const getslotmaster = async (outletCode) => {
    let getslotList = await SlotMasterList(outletCode);
    let getslotListValue = getslotList?.data?.data || [];

    let outmaster =
      getslotListValue &&
      getslotListValue.map(({ slotName, startTime, endTime, slotId }) => ({
        label: (
          <div>
            {" "}
            {slotName} - {startTime} - {endTime}{" "}
          </div>
        ),
        value: slotId,
      }));

    setSlotmaster(outmaster);

    // setSelectedslotmaster({
    //   label: <div>  {getslotListValue[0]?.slotName} - {getslotListValue[0]?.startTime} - {getslotListValue[0]?.endTime} </div>,
    //   value: getslotListValue[0]?.slotId,
    // });

    // setSelectedSlotTiming([...e]);
  };

  const getuomlist = async () => {
    let getuomList = await UomList();
    let getuomListValue = getuomList?.data?.data || [];
    let outmaster =
      getuomListValue &&
      getuomListValue.map(({ status, uomDescription, uomId }) => ({
        label: uomDescription,
        value: uomId,
      }));
    setUomlist(getuomListValue);
    setUomcategory(outmaster);
  };

  const getmainCategoryMaster = async (outletCode) => {
    let getslotList = await menuCategoryMasterList(outletCode);
    let getslotListValue = getslotList?.data?.data || [];
    let outmaster =
      getslotListValue &&
      getslotListValue.map(({ menuName, menuId }) => ({
        label: menuName,
        value: menuId,
      }));
    setCategoryMaster(outmaster);
    // console.log("getslotListValue", getslotListValue);
  };

  const savemenuAvailablity = async (key) => {
    // console.log("selectedSlotTiming", menuAvailablitMaster?.slotId);
    // return false;
    
    let data = "";
    let updatedata = "";
    let multinames =
      selectedSlotTiming &&
      selectedSlotTiming.map((item) => {
        return item["value"].toString();
      });
    let outletCode = restarantvalue.value;
    // adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let compCode = outletvalue.value;

    //console.log("menuAvailablitMaster",menuAvailablitMaster.planId);

    console.log("menuAvailablitMaster", menuAvailablitMaster);
    let plan =
      menuAvailablitMaster?.planId != "" &&
      menuAvailablitMaster?.planId != undefined &&
      menuAvailablitMaster?.planId.split("-");
    let planId = plan != "" && plan[0].trim();
    let planName = plan != "" && plan[1].trim();

    data = [
      {
        // dayId: menuAvailablitMaster?.dayId.toString(),
        // dayName: new Date().toLocaleDateString('en-us', { weekday: "long" }),
        // .toString(),
        dayId: selectedDateID === 0 ? 1 : selectedDateID,
        dayName: selectedDateName,
        // todayDate: formatDate(new Date())
        todayDate: selectedDateFormat,
        itemFlag: menuAvailablitMaster?.itemFlag || "ON",
        itemImagePath: "",
        outletCode: outletCode,
        slotFlag: menuAvailablitMaster?.slotFlag || "ON",
        menuId: menuAvailablitMaster?.menuId,
        // mainMenuId: menuAvailablitMaster?.mainMenuId != "" ? menuAvailablitMaster?.mainMenuId : 0,
        // subMenuId: menuAvailablitMaster?.menuId != 0 ? menuAvailablitMaster?.subMenuId : "",
        mainMenuId: selectedcategoryMaster?.value || 0,
        subMenuId: selectedsubcategoryMaster?.value || "",
        slotId: multinames || menuAvailablitMaster?.slotId,
        status: "A",
        price: priceAmountOfItem && priceAmountOfItem.toString(),
        qty: (quanitytyOfItem && quanitytyOfItem.toString()) || "1",
        uom: menuAvailablitMaster?.uom || "1",
        compCode,
        planId: Number(planId) || 0,
        planName: planName || "",
      },
    ];

    updatedata = {
      // dayId: menuAvailablitMaster?.dayId.toString(),
      // dayName: new Date().toLocaleDateString('en-us', { weekday: "long" }),
      // .toString(),
      // dayId: selectedDateID,

      dayId: selectedDateID === 0 ? 1 : selectedDateID,

      dayName: selectedDateName,
      // todayDate: formatDate(new Date())
      todayDate: selectedDateFormat,
      itemFlag: menuAvailablitMaster?.itemFlag || "ON",
      itemImagePath: "",
      outletCode: restarantvalue.value,
      // adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode,
      slotFlag: menuAvailablitMaster?.slotFlag || "ON",
      menuId: menuAvailablitMaster?.menuId,
      // mainMenuId: menuAvailablitMaster?.mainMenuId != "" ? menuAvailablitMaster?.mainMenuId : 0,
      // subMenuId: menuAvailablitMaster?.menuId != 0 ? menuAvailablitMaster?.subMenuId : "",

      mainMenuId: selectedcategoryMaster?.value || 0,
      subMenuId: selectedsubcategoryMaster?.value || "",

      slotId: multinames || menuAvailablitMaster?.slotId,
      status: "A",
      price: priceAmountOfItem && priceAmountOfItem.toString(),
      qty: quanitytyOfItem && quanitytyOfItem.toString(),
      uom: menuAvailablitMaster?.uom || "1",
      compCode,
      planId: Number(planId) || 0,
      planName: planName || "",
    };

    // console.log("data save",data);



    let reqforadupdatemenuitem;
    ////////
    if (editmenuavailablity === false) {
      reqforadupdatemenuitem = await saveofMenuAVL(data);
    } else {
      reqforadupdatemenuitem = await updateMenuAvailabilityREQ(updatedata);
    }

    menuPlanListREQ(selectedDateFormat);

    if (reqforadupdatemenuitem.data.status === true) {
      swal("Success!", "Menu Details Submitted", "success");
      onAddUpdateUserModalClose();

      setSelectedMenuItem({});
      setSelectedcategoryMaster({});
      setSelectedsubcategoryMaster({});
      setSelectedslotmaster({});
      onAddUpdateUserModalClose();
      setSelectedplanId({});
      setSelectedPopularMenu([]);
      setPriceAmountOfItem({});
      setSelectedSlotTiming([]);
      setMenuAvailablitMaster([]);
 

      // if (key === "addItem") {
      //   swal("Success!", "Menu Created", "success");
      //   onAddUpdateUserModalClose();
      // } else if (key === "updateItem") {
      //   swal("Success!", "Item Updated", "success");
      // } else if (key === "deleteItem") {
      //   swal("Success!", "Item Removed", "success");
      // }
    } else {
      swal("Oops", "Error, Please Try Later", "error");
      setSelectedMenuItem({});
      setSelectedcategoryMaster({});
      setSelectedsubcategoryMaster({});
      setSelectedslotmaster({});
      onAddUpdateUserModalClose();
      setSelectedplanId({});
      setSelectedPopularMenu([]);
      setPriceAmountOfItem({});
      setSelectedSlotTiming([]);
      setMenuAvailablitMaster([]);
   
    }


  };

  const updatemenuAvailablity = async (key, mainItem, submenuItem) => {
    // console.log("priceAmountOfItem", priceAmountOfItem);
    // console.log("submenuItem", submenuItem);
    // console.log("mainItem", mainItem);
    // console.log("key", key);
  
   setLoader(true);
    let data = "";
    let reqforadupdatemenuitem;
    //    // let outletCode =
    //         adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;

    // console.log("selectedSlotitem", submenuItem);
    // let selectedSlot = menuPlanList.find(
    //   (items, index) => items?.slotId === item?.slotId
    // );
    // console.log("selectedDateID", selectedDateID);
    // console.log("selectedDateName", selectedDateName);

    let compCode = outletvalue.value;

    if (key === "slotItemUpdate") {
      data = {
        // dayId: mainItem?.dayId,
        // dayName: mainItem?.dayName,
        // dayId: selectedDateID,
        dayId: selectedDateID === 0 ? 1 : selectedDateID,
        dayName: selectedDateName,
        itemFlag: mainItem?.itemFlag || "",
        itemImagePath: "",
        outletCode: restarantvalue.value,
        // adminToMangerOutletCode ||
        // loginDetails?.outletResponses[0]?.outletCode,
        slotFlag: mainItem?.slotFlag,
        menuId: mainItem?.menuId || "",
        mainMenuId: mainItem?.mainMenuId || "",
        subMenuId: mainItem?.subMenuId || "",
        slotId: [(mainItem?.slotId && mainItem?.slotId.toString()) || ""],
        status: "A",
        todayDate: "",
        price: priceAmountOfItem && priceAmountOfItem.toString(),
        qty: quanitytyOfItem && quanitytyOfItem.toString(),
        uom: "1",
        compCode,
        planId: menuAvailablitMaster.planId,
        planName: menuAvailablitMaster.planName,
      };
    } else if (key === "foodItemUpdate" || key === "deleteItem") {
      // console.log("selectedSlotitem1", mainItem);
      // console.log("selectedSlotitem2", submenuItem);
      data = {
        // dayId: mainItem?.dayId,
        // dayName: mainItem?.dayName,
        // dayId: selectedDateID,
        dayId: selectedDateID === 0 ? 1 : selectedDateID,
        dayName: selectedDateName,
        itemFlag: submenuItem?.itemFlag,
        itemImagePath: submenuItem?.itemPath,
        outletCode: restarantvalue.value,
        // adminToMangerOutletCode ||
        // loginDetails?.outletResponses[0]?.outletCode,
        slotFlag: mainItem?.slotFlag,
        menuId: submenuItem?.menuId,
        mainMenuId: submenuItem?.mainMenuId,
        subMenuId: submenuItem?.subMenuId,
        slotId: [(mainItem?.slotId && mainItem?.slotId.toString()) || ""],
        status: "A",
        todayDate: mainItem?.outletDate,
        // price: priceAmountOfItem && priceAmountOfItem.toString(),
        price: submenuItem?.price,
        /* qty: quanitytyOfItem && quanitytyOfItem.toString(), */
        qty: submenuItem?.quantity,
        uom: "1",
        compCode,
        planId: mainItem.planId,
        planName: mainItem.planName,
      };
    } else if (key === "daySlotOnOff") {
      let dayId = selectedDateID || new Date().getDay();
      // let dayId = new Date().getDay();
      // let dayId = new Date().getDay();
      let outletCode = restarantvalue.value;
      // adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
      let slotId = "";
      let todayDate = selectedDateFormat || formatDate(new Date());
      let status = dayOnOff === false ? "ON" : "OFF";
      let mlmfCategoryId = "";

      // console.log("mlmfCategoryId",mlmfCategoryId);
      reqforadupdatemenuitem = await apiReqOnOffDaySlot(
        dayId,
        outletCode,
        slotId,
        todayDate,
        status,
        mlmfCategoryId
      );
    } else if (key === "toggleTodaySlotOnOff") {
      let dayId = new Date().getDay();
      let outletCode =
        adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
      let slotId = "";
      let todayDate = formatDate(new Date());
      let status = dayOnOff === false ? "ON" : "OFF";
      let mlmfCategoryId = "";
      // console.log("mlmfCategoryId 2",mlmfCategoryId);

      reqforadupdatemenuitem = await apiReqOnOffDaySlot(
        dayId,
        outletCode,
        slotId,
        todayDate,
        status,
        mlmfCategoryId
      );
    } else if (key === "slotOnOff") {
      let dayId = selectedDateID;
      let outletCode = restarantvalue.value;
      // adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
      // let slotId = "";
      let slotId = [mainItem?.slotId && mainItem?.slotId.toString()];
      let status = mainItem?.slotFlag;
      // let todayDate = formatDate(new Date());
      let todayDate = mainItem?.outletDate;
      let mlmfCategoryId = mainItem.mlmfCategoryId;
      // console.log("mainItem",mainItem);
      // console.log("mlmfCategoryId 2",mlmfCategoryId);
      reqforadupdatemenuitem = await apiReqOnOffDaySlot(
        dayId,
        outletCode,
        slotId,
        todayDate,
        status,
        mlmfCategoryId
      );
    }

    /* return false; */
    if (key === "slotItemUpdate") {
      reqforadupdatemenuitem = await updateMenuAvailabilityREQ(data);
    } else if (key === "foodItemUpdate") {
      reqforadupdatemenuitem = await updateMenuAvailabilityREQ(data);
    } else if (key === "deleteItem") {
      reqforadupdatemenuitem = await deleteodmenuAVL(data);
      onRejectClose();
    }

    // menuPlanListREQ();
    menuPlanListREQ(selectedDateFormat || formatDate(new Date()));
    // await setMenuPlanList([]);

    if (reqforadupdatemenuitem.data.status === true) {
      setLoader(false);
      // if (key === "slotItemUpdate") {
      //   swal("Success!", "Slot Details Updated", "success");
      // } else if (key === "foodItemUpdate") {
      //   swal("Success!", "Item Availablity Updated", "success");
      // } else if (key === "deleteItem") {
      //   swal("Success!", "Item Details Removed", "success");
      // }
      // onAddUpdateUserModalClose();
      
     
    } else {
      swal("Oops", "Error, Please Try Later", "error");
      
    }
  };

  const blockInvalidChar = (e) => {
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
  };

  const onChangeCommonpopupsetOutletvalue = (key, value) => {
    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;
    const stringPattern = /^[-a-zA-Z-()]+(\s+[-a-zA-Z()]+)*$/;
    const stringwithnumberPattern = /^[-a-zA-Z0-9-()]+(\s+[-a-zA-Z0-9-()]+)*$/;
    const mobilePattern = /^[5-9][0-9]{9}$/;
    const emailPattern =
      /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([\.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i;

    if (key == "itemName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["itemName"] = "Item Name is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringwithnumberPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["itemName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["itemName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "itemPrice") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["itemPrice"] = "Item Price is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringwithnumberPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["itemPrice"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["itemPrice"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "itemQuantity") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["itemQuantity"] = "Item Quanity is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringwithnumberPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["itemQuantity"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["itemQuantity"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "itemDesc") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["itemDesc"] = "Item Desc is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["itemDesc"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "itemTag") {
      // console.log("value.length", value.length);
      //console.log("value.length", value[0]);
      // console.log("value.length", selected);
      // let trimmedvalue = value && value[0].trim();

      if (value[0] == "") {
        return false;
      } else {
        // const arr = [" zero ", " one ", " two "];
        const trimmedItemTagArray = value && value.map((item) => item.trim());
        // console.log("trimmedItemTagArray", trimmedItemTagArray);
        let duplicateItemTagArray = [...new Set(trimmedItemTagArray)];
        //console.log("duplicateItemTagArray", duplicateItemTagArray);
        const tempstatemaster =
          duplicateItemTagArray &&
          duplicateItemTagArray
            .filter((item) => item != "")
            .map((item) => {
              return item && item.toLowerCase();
            });

        // console.log("tempstatemaster", tempstatemaster);
        setSelected(tempstatemaster || []);

        addFieldValue = { [key]: value };
        errorsLocal["itemTag"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "uom") {
      if (!value) {
        addFieldValue = { [value.label]: null };
        errorsLocal["uom"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        setSelecteduomMaster({
          label: value.label,
          value: value.value,
        });
        errorsLocal["uom"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }
    const newFormData = { ...menulistitem };
    newFormData[key] = value;
    setMenulistitem(newFormData);
  };

  const onChangeCommonpopup = (key, value) => {
    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;

    if (key == "itemType") {
      addFieldValue = { [key]: value };
      setFormIsValid(formIsValidLocal);
    }

    if (key == "itemFoodImage") {
      const newFormData = { ...menulistitem };
      newFormData[key] = value.target.files[0];
      setMenulistitem(newFormData);
    } else {
      const newFormData = { ...menulistitem };
      newFormData[key] = value;
      setMenulistitem(newFormData);
    }
  };
  // save menu list//
  const submitFoodItemApi = async () => {
    let data = "";
    data = {
      compCode: outletvalue.value,
      itemDesc: menulistitem?.itemDesc,
      itemFoodImage: menulistitem?.itemFoodImage || "",
      itemId: selectedspecialMenu.value || "",
      itemName: menulistitem?.itemName,
      itemPrice: menulistitem?.itemPrice,
      itemTag: selected && selected.toString(),
      itemQuantity: "1",
      itemType: menulistitem?.itemType === true ? "veg" : "nonveg",
      outletCode: restarantvalue.value,
      status: "A",
      uom: selecteduomMaster?.value,
      planId: "",
      planName: "",
      itemImagePath: "",
      varient: [
        // { large: "", medium: "",small: "",  varientId:"", varientType:  ""}
      ],
    };

    console.log("data143256", data);

    let formData = new FormData();

    for (var key in data) {
      if (Array.isArray(data[key])) {
        data[key].forEach((obj, index) => {
          let keyName = [key, "[", index, "]"].join("");
          formData.append("itemFoodImage", obj);
        });
      } else {
        var f = new File([""], "filename");
        if (key == "itemFoodImage" && data["itemFoodImage"] == "") {
          formData.append(key, f);
        } else {
          formData.append(key, data[key]);
        }
      }
    }

    // console.log("formData", formData);
    // console.log("menuSubmenuItems?.itemId", menuSubmenuItems?.itemId);
    // return false;

    let reqformenusubmenu = await addOutletItem(formData);

    if (reqformenusubmenu.data.status === true) {
      swal("Success!", "Item Added", "success");
      setMenulistitem({});
      setMenulistpopup(false);
      let outletCode = restarantvalue.value;
      //  adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
      let compCode = outletvalue.value;
      //adminToMangerCompanyCode || loginDetails?.companyCode;
      getmenulist(compCode, outletCode);
      setMenulistpopup(false);
      setSelectedplanId([]);
      setSelectedPopularMenu([]);
    } else {
      swal("Oops", "Error, Please Try Later", "error");
      setMenulistpopup(false);
      let outletCode = restarantvalue.value;
      //adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
      let compCode = outletvalue.value;
      //adminToMangerCompanyCode || loginDetails?.companyCode;
      getmenulist(compCode, outletCode);
      setMenulistitem({});
      setSelectedplanId([]);
      setSelectedPopularMenu([]);
    }
  };

  // generate image to pdf//
  /* const handleGeneratePdf = () => {
      const input = document.getElementById("App")
      console.log("input",input);
      html2canvas(input,{logging: true,letterRendering: 1,allowTaint: false}).then(canvas => {
        const imgWidth = 208;
        const imgHeight =canvas.height * imgWidth / canvas.width;
         const imgData = canvas.toDataURL(input);
         console.log("imgData",imgData);
      
      img.src = {selectedViewMoreslotsDetails?.itemPath};
        const doc = new jsPDF('a4');
        doc.addImage(imgData,'PNG',0,0,imgWidth,imgHeight);
        doc.save("document");
      })  
    }; */
  /*  const doc = new jsPDF({
       format: "a4",
       unit: "px"
     });
     doc.internal.scaleFactor = 2.25;
  
     doc.html(reportTemplateRef.current, {
       async callback(doc) {
         await doc.save("document");
       }
     }); */

  /*  doc.html(document.getElementById('slotId'),
     { allowTaint: true },
     function () {
       doc.save('test.pdf');
     }
   ); */

  /* doc.html(reportTemplateRef.current,(doc),
      { allowTaint: true },
      function () {
        doc.save('test.pdf');
      }
    ); */

  //Subscription popular list

  const getRestarantPopularlist = async (e) => {
    let restaurantId = e;

    let getresmenuid = await getresbasedPopularMenumaster(restaurantId);
    //  console.log("getresmenuid", getresmenuid);

    let getresmenu = getresmenuid.data.data || [];

    //  console.log("getresmenu getresmenu", getresmenu);

    let specialmenulist = getresmenu.map(({ id, name, price }) => ({
      label: name,
      value: `${id}- ${name}-${price} `,
    }));
    setPopularMenu(specialmenulist);
  };

  //Plan Id subscription data
  const getSubscrptionList = async (outletCode) => {
    let getplanList = await subscriptionPlanId(outletCode);
    let getplanidValue = getplanList.data.data || [];
    //setSubPlanId(getplanidValue);
    let Selectedplan = getplanidValue.map(({ planId, planName, amount }) => ({
      label: `${planName} - ${amount}`,
      value: `${planId} - ${planName}`,
      price: `${amount}`,
    }));
    setSubPlanId(Selectedplan);
  };

  //multiselect//
  const CustomClearText = () => "clear all";
  const ClearIndicator = (props) => {
    const {
      children = <CustomClearText />,
      getStyles,
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div
        {...restInnerProps}
        ref={ref}
        style={getStyles("clearIndicator", props)}
      >
        <div style={{ padding: "0px 5px" }}>{children}</div>
      </div>
    );
  };
  const ClearIndicatorStyles = (base, state) => ({
    ...base,
    cursor: "pointer",
    color: state.isFocused ? "blue" : "black",
  });

  const getsubcategoryMaster = async (mainMenuId) => {
    let outletCode = restarantvalue.value;
    //  adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    //  let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;

    let getslotList = await submenuCategoryMasterList(outletCode, mainMenuId);
    let getslotListValue = getslotList?.data?.data || [];

    let outmaster =
      getslotListValue &&
      getslotListValue.map(({ subMenuName, subMenuId }) => ({
        label: subMenuName,
        value: subMenuId,
      }));
    setSubcategoryMaster(outmaster);
    // console.log("getslotListValue", getslotListValue);
  };

  function handleRemove(id) {
    const newList = content.filter((item) => item.id !== id);
    setContent(newList);
  }

  const d = new Date();

  const options = {
    settings: {
      overlayColor: "#000000",
    },
  };

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  const handleMenuAvail = (isCheck, index) => {
    setFoodToggle(isCheck);
    let foodMenuUpdate = foodmenu.map((item, i) => {
      if (i == index) {
        return { ...item, status: isCheck };
      } else {
        return item;
      }
    });
    setFoodmenu(foodMenuUpdate);
    if (isCheck) {
      menutoggle();
      setTempselecteuser(foodmenu[index]);
    }
  };

  const handleafternoonAvail = (isCheck, index) => {
    setFoodToggle(isCheck);
    let foodMenuUpdate = afternnonmenu.map((item, i) => {
      if (i == index) {
        return { ...item, status: isCheck };
      } else {
        return item;
      }
    });
    setAfternnoonmenu(foodMenuUpdate);
    if (isCheck) {
      menutoggle();
      setTempselecteuser(afternnonmenu[index]);
    }
  };

  const onAddUpdateUserModalClose = () => {
    setPopUpPageShow(!popUpPageShow);
  };

  const onMenuClose = () => {
    setMenulistpopup(!menulistpopup);
  };

  const OnRejectModal = (e) => {
    setRejectModal(true);
    e.preventDefault();
  };

  const onRejectClose = () => {
    setRejectModal(!rejectModal);
  };

  const menutoggle = () => {
    setTogglemodal(true);
  };

  const onToggleClose = () => {
    setTogglemodal(!togglemodal);
  };

  function getSteps() {
    return ["Order's List", "KOT", "Delivery"];
  }

  const eyeOnClickCardViewMoreSlot = () => {
    // menuPlanList &&
    //   menuPlanList.map((items) => {
    //     setSelectedDateName(items.dayName);
    //     setSelectedDateFormat(items.outletDate);
    //     setSelectedDateID(items.dayId);
    //     // menuPlanListREQ(items.outletDate);
    //   });
    // setSelectedViewMoreslotsDetails(menuPlanList);
    // setViewmoreslots(true);
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <OrderDetailsForm />;

      case 1:
        return <KotForm time={time} tips={tips} packing={packing} />;

      case 2:
        return <DeliveryForm location={location} />;
      /* case 3:
            return <BankDetails />; */
      default:
        return <OrderDetailsForm />;
    }
  }

  const isStepOptional = (step) => {
    return step === 1 || step === 2;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleStep = (step) => {
    setActiveStep(step);
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const totalSteps = () => {
    return getSteps().length;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps() - skippedSteps();
  };

  const completedSteps = () => {
    return completed.size;
  };

  const skippedSteps = () => {
    return skipped.size;
  };
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const accept = () => {
    let activeStep2 = "";

    /* const {
          subitem,
          price,
          foodtype,
          description,
          quantity,
          image,
          starttime,
          endtime,
        } = menudetails; */

    /* if (activeStep === 0) {
          console.log("restaurantDetails", restaurantDetails);
          console.log("step", restaurantDetails);
          if (
            restaurantDetails === null &&
            restName !== "" &&
            restMobileNumber !== "" &&
            restEmailId !== ""
          ) {
            NotificationManager.warning("ALL Field is mandatory..!!");
            return false;
          }
        } */

    if (isLastStep() && !allStepsCompleted()) {
      // It's the last step, but not all steps have been completed
      // find the first step that has been completed
      const steps = getSteps();
      activeStep2 = steps.findIndex((step, i) => !completed.has(i));
    } else {
      activeStep2 = activeStep + 1;
    }

    const completed2 = new Set(completed);
    completed2.add(activeStep);
    setActiveStep(activeStep2);
    setCompleted(completed2);
  };

  const copytonext = async (initialindex) => {
    const [day, month, year] =
      weeklyMenuMasterOfPastCurrentNextWeeks[initialindex]?.outletDate.split(
        "/"
      );
    let dateschec = new Date(+year, month - 1, day);
    let fomratdate = formatDate(dateschec);
    let fomratdateid = dateschec.getDay() + 1;
    let fomratdatename = dateschec.toLocaleDateString("en-us", {
      weekday: "long",
    });
    let outletCode = restarantvalue.value;
    // adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let slotFlag = "ON";
    let reqforadupdatemenuitem;
    reqforadupdatemenuitem = await copyofMenuAVLnext(
      outletCode,
      fomratdate,
      fomratdateid
    );
    setSelectedMenuType("weekly");
    if (reqforadupdatemenuitem.data.status === true) {
      swal("Success!", "Menu Created for next day", "success");
      onAddUpdateUserModalClose();
    } else {
      swal("Oops", "Error, Please Try Later", "error");
    }
    weeekMasterApiCall(selectedWeekType ? selectedWeekType : "currentWeek");
  };

  return (
    <>
      <div className="row loaderPostn" id="slotId" style={{minHeight:"400px"}}>
      {loader && <RctSectionLoader />}
        <>
          {selectedMenuType == "" && (
            <div className="row">
              <div class="col-sm-4 col-md-4 col-xl-4 form-group">
                <h3
                  className="me-auto"
                  style={{ fontFamily: "Roboto", color: "darkgreen" }}
                >
                  Menu Planner
                </h3>
              </div>

              <div class="col-sm-4 col-md-4 col-xl-4 form-group">
                <label as="a" variant="badge badge-rounded badge-danger">
                  Company
                </label>
                <Select
                  options={companyMaster}
                  value={outletvalue}
                  closeMenuOnSelect={true}
                  search
                  name="stateCode"
                  placeholder="Choose"
                  autoComplete="off"
                  onChange={(event) => {
                    setRestarantvalue({ label: "", value: "" });
                    setOutletvalue(event);
                    getoutletMasterList(event?.value);
                  }}
                />
              </div>
              <div class="col-sm-4 col-md-4 col-xl-4 form-group">
                <label as="a" variant="badge badge-rounded badge-danger">
                  Restaurant
                </label>
                <Select
                  options={outletMasterlist}
                  value={restarantvalue}
                  closeMenuOnSelect={true}
                  search
                  name="stateCode"
                  placeholder="Choose"
                  autoComplete="off"
                  onChange={(event) => {
                    // setMenucategory([]);
                    // setCategoryMaster([]);
                    // subcategoryMaster([]);
                    // setSelectedMenuItem({ label: "", value: "", })
                    // setSelectedsubcategoryMaster({ label: "", value: "", })
                    // setSelectedcategoryMaster({ label: "", value: "", })

                    setRestarantvalue(event);
                    //console.log("eventrest", event);
                    getRestarantmenulist(event);

                    let todayformat = formatDate(new Date());
                    menuPlanListREQ(todayformat, event.value);
                    getslotmaster(event.value);
                    getmainCategoryMaster(event.value);
                    let compCode = outletvalue.value;
                    getmenulist(compCode, event.value);
                    getRestarantPopularlist(event?.restaurantId);
                    getSubscrptionList(event?.restaurantId);
                    // getmenulist(outletvalue?.value, event?.value);
                    // getmainCategoryMaster(event?.value);
                  }}
                />
              </div>
            </div>
          )}
        </>
        <div className="col">
          {selectedMenuType == "today" && (
            <>
              <h4>
                {" "}
                {restarantvalue.label}-{selectedDateName} - {selectedDateFormat}{" "}
              </h4>

              {selectedWeekType != "pastWeek" &&
                menuPlanList &&
                menuPlanList.length > 0 && (
                  <div class="col-sm-6 col-md-5 col-xl-5 ">
                    <Switch
                      checked={dayOnOff === true}
                      style={{
                        color: dayOnOff === true ? "green" : "red",
                      }}
                      onChange={() => {
                        updatemenuAvailablity("daySlotOnOff", "", "");
                      }}
                      aria-label="checkedA"
                    />{" "}
                    <span
                      style={{
                        color: dayOnOff === true ? "green" : "red",
                        fontSize: "x-small",
                        marginLeft: "-8px",
                      }}
                    >
                      {dayOnOff === true ? "" : "OFF"}
                    </span>
                  </div>
                )}
            </>
          )}

          {selectedMenuType == "weekly" && (
            <div className="btn-page">
              <Row>
                <Col lg="12">
                  <Button
                    className="me-1"
                    variant="info"
                    onClick={() => {
                      setWeeklyMenuMasterOfPastCurrentNextWeeks([]);
                      weeekMasterApiCall("pastWeek");
                      setSelectedWeekType("pastWeek");
                      setArrowRightLeft(false);
                    }}
                    style={{
                      backgroundColor:
                        selectedWeekType == "pastWeek" ? "#0a5c0a" : "grey",
                    }}
                  >
                    <i class="fas fa-arrow-left"></i> {`  `}
                    Previous
                  </Button>

                  <Button
                    className="me-1"
                    variant="success"
                    onClick={() => {
                      setWeeklyMenuMasterOfPastCurrentNextWeeks([]);
                      weeekMasterApiCall("currentweek");
                      setSelectedWeekType("currentweek");
                      setArrowRightLeft(false);
                    }}
                    style={{
                      backgroundColor:
                        selectedWeekType == "currentweek" ? "#0a5c0a" : "grey",
                    }}
                  >
                    {" "}
                    This Week{" "}
                  </Button>

                  <Button
                    className="me-2"
                    variant="secondary"
                    style={{
                      backgroundColor:
                        selectedWeekType == "nextweek" ? "#0a5c0a" : "grey",
                    }}
                    onClick={() => {
                      setWeeklyMenuMasterOfPastCurrentNextWeeks([]);
                      weeekMasterApiCall("nextweek");
                      setSelectedWeekType("nextweek");
                      setArrowRightLeft(false);
                    }}
                  >
                    Next
                    <i class="fas fa-arrow-right"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          )}

          {selectedMenuType == "Tomorrow" && (
            <>
              <h4>
                {" "}
                {restarantvalue.label} - {selectedDateName} -{" "}
                {selectedDateFormat}{" "}
              </h4>
              {menuPlanList && menuPlanList.length > 0 && (
                <div class="col-sm-6 col-md-5 col-xl-5 ">
                  <Switch
                    checked={dayOnOff === true}
                    style={{
                      color: dayOnOff === true ? "green" : "red",
                    }}
                    onChange={() => {
                      updatemenuAvailablity("daySlotOnOff", "", "");
                    }}
                    aria-label="checkedA"
                  />{" "}
                  <span
                    style={{
                      color: dayOnOff === true ? "green" : "red",
                      fontSize: "x-small",
                      marginLeft: "-8px",
                    }}
                  >
                    {dayOnOff === true ? "" : "OFF"}
                  </span>
                </div>
              )}
            </>
          )}
          <br />
        </div>

        <div className="col lg-12 ">
          {(selectedMenuType == "today" || selectedMenuType == "Tomorrow") && (
            <>
              {/* <div className="col-xl-12 pos-rel"> */}

              <div
                className="col-xl-12"
                style={{ position: "relative", display: "flex" }}
              >
                {selectedWeekType != "pastWeek" && (
                  <>
                    <div className="col-xl-6 ">
                      <label
                        as="a"
                        variant="badge badge-rounded badge-danger"
                        onClick={() => {
                          onAddUpdateUserModalClose();
                        }}
                      >
                        Menu Item
                      </label>

                      <Select
                        styles={{ width: "250px" }}
                        options={menufetchitem}
                        className="menu-select-box"
                        search
                        placeholder="Search"
                        autoComplete="off"
                        value={selectedMenuItem}
                        // onChange={() => { onAddUpdateUserModalClose() }}
                        onChange={(e) => {
                          // console.log("menuAvailablitMaster", menuAvailablitMaster);
                          // console.log("e e e", e.value);
                          const values = e.value && e.value.split("-");
                          let menuId = values && values[0].trim();
                          let mainnemuid = values && values[1].trim();
                          let submenuid = values && values[2].trim();
                          let itemprice = values && values[3].trim();
                          let itemquantity = values && values[4].trim();
                          let uomvalue = values && values[5].trim();
                          let categoryName = values && values[6].trim();
                          let subCategoryName = values && values[7].trim();
                          setEditmenuavailablity(false);
                          setPriceAmountOfItem(itemprice);
                          setQuanitytyOfItem(itemquantity);

                          // console.log("emainnemuid", mainnemuid);
                          // console.log("esubmenuid", submenuid);
                          // console.log("emainnemuid", categoryName);
                          // console.log("esubmenuid", subCategoryName);

                          setSelectedcategoryMaster({
                            label: categoryName,
                            value: mainnemuid,
                          });
                          setSelectedsubcategoryMaster({
                            label: subCategoryName,
                            value: submenuid,
                          });

                          setCatSubFromSelectedMenu(menuId);
                          setSelectedMenuItem(e);
                          setSelectedslotmaster({ label: "", value: "" });
                          // setSelectedMenuItem({
                          //   label: e,
                          //   value: menuId
                          // });
                          const newFormData = { ...menuAvailablitMaster };
                          newFormData["menuId"] = menuId;
                          newFormData["uom"] = uomvalue;
                          // newFormData["mainMenuId"] = mainnemuid;
                          // newFormData["subMenuId"] = submenuid;
                          setMenuAvailablitMaster(newFormData);
                          // onAddUpdateUserModalClose();
                          setPopUpPageShow(true);
                          setSubPopUpPageShow(false);
                        }}
                      />
                      {/* <span className="plus-icon">
                                                <i
                                                    class="fas fa-plus"
                                                    onClick={() => {
                                                        setMenulistitem({
                                                            itemDesc: "",
                                                            itemFoodImage: "",
                                                            itemImagePath: "",
                                                            itemId: "",
                                                            itemName: "",
                                                            itemPrice: "",
                                                            itemQuantity: "",
                                                            itemType: true,
                                                            itemTag: "",
                                                            uom: "",
                                                        });
                                                        setMenulistpopup(true);
                                                    }}
                                                >
                                                    {/*  Add Item{" "}  }
                                              </i>
                                            </span> */}
  
                    </div>

                    <div
                      class="col-4 col-md-4 col-lg-4 form-group main-frm-grp"
                      style={{ width: "10%" }}
                    >
                      <>
                        {/* <i
                          className="fa fa-download mt-4"
                          onClick={saveExcel}
                          // disabled={restarantvalue.value == ""}
                          style={{ marginRight: "13px", color: "green" }}
                        ></i> */}
                        <Button
                          className=""
                          variant="success dark btn-sm"
                          // disabled={restarantvalue.value == ""}
                          style={{
                            backgroundColor: "#1F3DB6",
                            borderRadius: "2px",
                            border: "0px solid",
                            height: "36px",
                            padding: "6px",
                            marginTop: "27px",
                          }}
                          onClick={() => {
                            // getSubscriptionList();

                            setPopUpPageShow(true);
                            setSubPopUpPageShow(true);
                            getSubscrptionList(restarantvalue.restaurantId);
                          }}
                        >
                          <i
                            class="fas fa-plus"
                            onClick={() => {
                              // getSubscriptionList();
                            }}
                          >
                            Subscription Item{" "}
                          </i>{" "}
                        </Button>
                      </>
                    </div>
                  </>
                )}

                <br />
                {popUpPageShow && (
                  <div
                    className="row pos-abs menu-choose-con"
                    // {/* <div className="row" */}
                    style={{
                      borderStyle: "groove",
                      top: "70px",
                      // position: "absolute !important",
                      // background: "#fff",
                      // padding: "10px",
                      // width: "900px",
                      // left: "-250px"
                    }}
                  >
                    {/* <div class="col-sm col-md-6 form-group">
                      <label
                        as="a"
                        variant="badge badge-rounded badge-danger"
                      >
                        Time
                      </label>
                      <Select
                        options={timeslot}
                        search
                        placeholder="Time"
                        autoComplete="off"
                      /></div> */}
                    {subPopUpPageShow == true && (
                      <div class="col-sm col-md-3 form-group">
                        <label
                          as="a"
                          variant="badge badge-rounded badge-danger"
                        >
                          Subscription Item
                        </label>
                        <Select
                          options={popularmenu}
                          search
                          placeholder="Subscription Menu"
                          value={selectedPopularMenu}
                          autoComplete="off"
                          // onChange={(e) => { getsubcategoryMaster(e.value) }}
                          onChange={(e) => {
                            const values = e.value.split("-");
                            let menuId = values && values[0].trim();
                            // let mainnemuid = values && values[1].trim();
                            // let submenuid = values && values[2].trim();
                            let itemprice = values && values[2].trim();
                            // let itemquantity = values && values[4].trim();
                            // let uomvalue = values && values[5].trim();
                            // let categoryName = values && values[6].trim();
                            // let subCategoryName = values && values[7].trim();
                            setEditmenuavailablity(false);
                            setPriceAmountOfItem(itemprice);
                            // setQuanitytyOfItem(itemquantity);

                            // console.log("emainnemuid", mainnemuid);
                            // console.log("esubmenuid", submenuid);
                            // console.log("emainnemuid", categoryName);
                            // console.log("esubmenuid", subCategoryName);

                            // setSelectedcategoryMaster({
                            //   label: categoryName,
                            //   value: mainnemuid,
                            // });
                            // setSelectedsubcategoryMaster({
                            //   label: subCategoryName,
                            //   value: submenuid,
                            // });

                            setCatSubFromSelectedMenu(menuId);

                            setSelectedPopularMenu(e);
                            setSelectedslotmaster({ label: "", value: "" });
                            // setSelectedMenuItem({
                            //   label: e,
                            //   value: menuId
                            // });
                            const newFormData = { ...menuAvailablitMaster };
                            newFormData["menuId"] = menuId;
                            // newFormData["uom"] = uomvalue;
                            // newFormData["mainMenuId"] = mainnemuid;
                            // newFormData["subMenuId"] = submenuid;
                            setMenuAvailablitMaster(newFormData);
                            // onAddUpdateUserModalClose();
                            //setSubPopUpPageShow(false);
                          }}
                          isDisabled={editmenuavailablity}
                        />
                      </div>
                    )}

                    <div class="col-sm col-md-3 form-group" >
                      <label as="a" variant="badge badge-rounded badge-danger">
                        Category
                      </label>
                      <Select
                        options={categoryMaster}
                        search
                        placeholder="Category"
                        value={selectedcategoryMaster}
                        autoComplete="off"
                        // onChange={(e) => { getsubcategoryMaster(e.value) }}
                        onChange={(e) => {
                          //
                          // console.log("menuAvailablitMaster", menuAvailablitMaster);
                          setSelectedcategoryMaster(e);
                          getsubcategoryMaster(e.value);
                          const newFormData = { ...menuAvailablitMaster };
                          newFormData["mainMenuId"] = e.value;
                          setMenuAvailablitMaster(newFormData);
                        }}
                        isDisabled={editmenuavailablity}
                      />
                    </div>

                    <div class="col-sm col-md-3 form-group">
                      <label as="a" variant="badge badge-rounded badge-danger">
                        Sub Category
                      </label>
                      <Select
                        options={subcategoryMaster}
                        search
                        placeholder="SubCategory"
                        autoComplete="off"
                        value={selectedsubcategoryMaster}
                        onChange={(e) => {
                          setSelectedsubcategoryMaster(e);
                          const newFormData = { ...menuAvailablitMaster };
                          newFormData["subMenuId"] = e.value;
                          setMenuAvailablitMaster(newFormData);
                        }}
                        isDisabled={editmenuavailablity}
                      />
                    </div>

                    <div class="col-sm col-md-3 form-group">
                      <label as="a" variant="badge badge-rounded badge-danger">
                        Item Price
                      </label>
                      <Input
                        type="number"
                        min="0"
                        // name="itemname"
                        // id="itemname"
                        placeholder="Item Price"
                        // maxLength="25"
                        required
                        autoComplete="off"
                        onKeyDown={blockInvalidChar}
                        onChange={(e) => {
                          if (e.target.value.length > 5) {
                            alert(" Amount not allowed!");
                            return false;
                          } else if (e.target.value === 0) {
                            alert(" Amount 0 not allowed!");
                            return false;
                          } else {
                            setPriceAmountOfItem(e.target.value);
                          }
                        }}
                        value={priceAmountOfItem}
                        style={{ height: "36px" }}
                      />
                    </div>

                    <div className="mb-6 col-md-6">
                      <label as="a" variant="badge badge-rounded badge-danger">
                        Outlet Timings
                      </label>
                      <Select
                        options={slotmaster}
                        // defaultValue={selectedOutletvalue}
                        isMulti
                        // value={selectedslotmaster || { label: "", value: "" }}
                        // value={selectedslotmaster}
                        value={
                          selectedslotmaster &&
                          selectedslotmaster["value"] != ""
                            ? selectedslotmaster
                            : ""
                        }
                        closeMenuOnSelect={false}
                        styles={{
                          clearIndicator: ClearIndicatorStyles,
                        }}
                        components={{ ClearIndicator }}
                        search
                        name="stateCode"
                        placeholder="Choose"
                        isDisabled={editmenuavailablity}
                        onChange={(e) => {
                          // console.log("", selectedslotmaster)
                          // console.log("",   (let  value of selectedslotmaster )  items.value != ""))
                          setSelectedslotmaster(e);
                          setSelectedSlotTiming([...e]);
                          // const newFormData = {...menuAvailablitMaster};
                          // newFormData["slotId"] = [...e.value];
                          // setMenuAvailablitMaster(newFormData);
                        }}
                        autoComplete="off"
                      />
                    </div>

                    {subPopUpPageShow == true && (
                      <div class="col-sm col-md-3 form-group">
                        <label
                          as="a"
                          variant="badge badge-rounded badge-danger"
                        >
                          Select Plan Name
                        </label>
                        <Select
                          options={subPlanId}
                          search
                          placeholder="Plan Name"
                          autoComplete="off"
                          // value={menuAvailablitMaster.planId}
                          onChange={(e) => {
                            // setSelectedsubcategoryMaster(e);
                            const newFormData = { ...menuAvailablitMaster };
                            newFormData["planId"] = e.value;
                            setMenuAvailablitMaster(newFormData);
                            setSelectedplanId(e.value);
                          }}
                          isDisabled={editmenuavailablity}
                        />
                      </div>
                    )}

                    {/* <div class="row"> */}
                    {/* <div class="col-sm col-md-12 form-group text-center mt-3"> */}
                    <div className="mb-6 col-md-6">
                      <br />
                      <Button
                        className="me-2"
                        variant="success"
                        onClick={() => {
                          setSelectedMenuItem({});
                          if (editmenuavailablity === false) {
                            savemenuAvailablity();
                          } else {
                            savemenuAvailablity("update");
                          }
                        }}
                        style={{ color: "black" }}
                        disabled={
                          selectedslotmaster.value === "" ||
                          priceAmountOfItem == ""
                        }
                      >
                        Submit
                      </Button>
                      <Button
                        variant="danger light"
                        onClick={() => {
                          setSelectedMenuItem({});
                          setSelectedcategoryMaster({});
                          setSelectedsubcategoryMaster({});
                          setSelectedslotmaster({});
                          onAddUpdateUserModalClose();
                          setSelectedplanId({});
                          setSelectedPopularMenu([]);
                          setPriceAmountOfItem({});
                          setSelectedSlotTiming([]);
                          setSubPopUpPageShow(false);
                          setMenuAvailablitMaster([]);
                        }}
                      >
                        Cancel
                      </Button>
                      {/* </div> */}
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        <div className="col">
          {todaymenuPopup === false && selectedMenuType != "" && (
            <div
              className="basic-dropdown menu-drop-btn"
              style={{ marginLeft: "230px" }}
            >
              <Dropdown>
                <Dropdown.Toggle variant="primary">Menu</Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      setSelectedDateName(
                        new Date().toLocaleDateString("en-us", {
                          weekday: "long",
                        })
                      );
                      setSelectedDateFormat(formatDate(new Date()));
                      setSelectedDateID(new Date().getDay());
                      setSelectedMenuType("today");
                      setTodaymenuPopup(true);
                      menuPlanListREQ(formatDate(new Date()));
                      setSelectedWeekType("currentweek");
                    }}
                  >
                    Today Menu
                  </Dropdown.Item>

                  <Dropdown.Item
                    href="#"
                    onClick={async () => {
                      let dateschec = new Date();
                      dateschec.setDate(new Date().getDate() + 1);
                      await setSelectedDateFormat(formatDate(dateschec));
                      await setSelectedDateID(dateschec.getDay());
                      await setSelectedDateName(
                        dateschec.toLocaleDateString("en-us", {
                          weekday: "long",
                        })
                      );
                      await setTodaymenuPopup(true);
                      await setSelectedMenuType("Tomorrow");
                      await menuPlanListREQ(formatDate(dateschec));
                      setSelectedWeekType("currentweek");
                    }}
                  >
                    Tomorrow Menu
                  </Dropdown.Item>

                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      setTodaymenuPopup(true);
                      setSelectedMenuType("weekly");
                      setSelectedWeekType("currentweek");
                    }}
                  >
                    This Week Menu
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
          {todaymenuPopup === true && selectedMenuType != "" && (
            <div
              className="basic-dropdown menu-drop-btn"
              style={{ marginLeft: "292px" }}
            >
              {/* <Button
                  variant="danger light"
                  onClick={() => {
                    setTodaymenuPopup(false);
                    setSelectedMenuType("");
                  }}
                >
                  Back
                </Button> */}

              <Dropdown>
                <Dropdown.Toggle variant="primary">Menu</Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      setTodaymenuPopup(false);
                      setSelectedMenuType("");
                      // setSelectedMenuType("Tomorrow");
                      setPopUpPageShow(false);
                      setSelectedMenuItem({});
                      menuPlanListREQ(formatDate(new Date()));
                      setSelectedWeekType("currentweek");
                      // setSelectedDateName(
                      //   new Date().toLocaleDateString("en-us", {
                      //     weekday: "long"
                      //   }));
                      // setSelectedDateFormat(formatDate(new Date()));
                      // setSelectedDateID(new Date().getDay());
                    }}
                  >
                    Back to menu
                  </Dropdown.Item>

                  {selectedMenuType == "weekly" && (
                    <>
                      <Dropdown.Item
                        href="#"
                        onClick={async () => {
                          await setSelectedDateID(new Date().getDay());
                          await setSelectedDateName(
                            new Date().toLocaleDateString("en-us", {
                              weekday: "long",
                            })
                          );
                          await setSelectedDateFormat(formatDate(new Date()));
                          await setSelectedMenuType("today");
                          await setSelectedWeekType("currentweek");
                          // await menuPlanListREQ();
                          await menuPlanListREQ(formatDate(new Date()));
                          setPopUpPageShow(false);
                        }}
                      >
                        Today Menu
                      </Dropdown.Item>

                      <Dropdown.Item
                        href="#"
                        onClick={async () => {
                          let dateschec = new Date();
                          dateschec.setDate(new Date().getDate() + 1);
                          await setSelectedDateFormat(formatDate(dateschec));
                          await setSelectedDateID(dateschec.getDay());
                          await setSelectedDateName(
                            dateschec.toLocaleDateString("en-us", {
                              weekday: "long",
                            })
                          );
                          await setSelectedMenuType("Tomorrow");
                          await setSelectedWeekType("currentweek");
                          await menuPlanListREQ(formatDate(dateschec));
                          setPopUpPageShow(false);
                        }}
                      >
                        Tomorrow Menu
                      </Dropdown.Item>
                    </>
                  )}

                  {selectedMenuType == "today" && (
                    <>
                      <Dropdown.Item
                        href="#"
                        onClick={() => {
                          setWeeklyMenuMasterOfPastCurrentNextWeeks([]);
                          setSelectedMenuItem({});
                          setSelectedDateName("");
                          // setSelectedDateName("")
                          setSelectedMenuType("weekly");
                          // weeekMasterApiCall("currentWeek");
                          setPopUpPageShow(false);
                          weeekMasterApiCall(
                            selectedWeekType ? selectedWeekType : "currentWeek"
                          );
                        }}
                      >
                        Weekly Menu
                      </Dropdown.Item>

                      <Dropdown.Item
                        href="#"
                        onClick={async () => {
                          let dateschec = new Date();
                          dateschec.setDate(new Date().getDate() + 1);
                          await setSelectedDateFormat(formatDate(dateschec));
                          await setSelectedDateID(dateschec.getDay());
                          await setSelectedDateName(
                            dateschec.toLocaleDateString("en-us", {
                              weekday: "long",
                            })
                          );
                          await setSelectedMenuType("Tomorrow");
                          await menuPlanListREQ(formatDate(dateschec));
                          setPopUpPageShow(false);
                        }}
                      >
                        Tomorrow Menu
                      </Dropdown.Item>
                    </>
                  )}

                  {selectedMenuType == "Tomorrow" && (
                    <>
                      <Dropdown.Item
                        href="#"
                        onClick={() => {
                          setSelectedDateName("");
                          setSelectedMenuItem({});
                          setSelectedMenuType("weekly");
                          setPopUpPageShow(false);
                          setWeeklyMenuMasterOfPastCurrentNextWeeks([]);
                          weeekMasterApiCall(
                            selectedWeekType ? selectedWeekType : "currentWeek"
                          );
                        }}
                      >
                        Weekly Menu
                      </Dropdown.Item>

                      <Dropdown.Item
                        href="#"
                        onClick={async () => {
                          await setSelectedDateID(new Date().getDay());
                          await setSelectedDateName(
                            new Date().toLocaleDateString("en-us", {
                              weekday: "long",
                            })
                          );
                          await setSelectedDateFormat(formatDate(new Date()));
                          await setSelectedMenuType("today");

                          await setSelectedWeekType("currentweek");

                          // await menuPlanListREQ();
                          await menuPlanListREQ(formatDate(new Date()));
                          setPopUpPageShow(false);
                        }}
                      >
                        Today's Menu
                      </Dropdown.Item>
                    </>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
          <br />
        </div>

        {todaymenuPopup === false && selectedMenuType == "" && (
          // <main className="App"
          //   style={{
          //     fontFamily: "sans-serif",
          //     textAlign: "center",
          //     padding: "0.5em"
          //   }}
          // >
          //   <hr />
          //   <Board columnItems={board} onColumnItemsChange={setBoard} />
          // </main>

          <>
            <n /> <n />
            <Col xl="4">
              <Card
                className=""
                // onClick={() => {
                //   setSelectedDateName(new Date().toLocaleDateString('en-us', { weekday: "long" }));
                //   setSelectedDateFormat(formatDate(new Date()));
                //   setSelectedDateID(new Date().getDay());
                // setSelectedMenuType("today");
                //   setTodaymenuPopup(true);
                //   menuPlanListREQ(formatDate(new Date()));
                // }
                // }
              >
                <Card.Header
                  style={{ backgroundColor: "green", height: "60px" }}
                >
                  <Card.Title style={{ color: "white" }}>
                    {" "}
                    Today Menu
                  </Card.Title>

                  {menuPlanList && menuPlanList.length > 0 && (
                    <div class="col-sm-6 col-md-5 col-xl-5 ">
                      <Switch
                        checked={dayOnOff === true}
                        style={{
                          color: dayOnOff === true ? "greenyellow" : "red",
                        }}
                        onChange={() => {
                          setSelectedDateFormat(formatDate(new Date()));
                          // menuPlanListREQ(formatDate(new Date()));
                          setSelectedDateName(
                            new Date().toLocaleDateString("en-us", {
                              weekday: "long",
                            })
                          );
                          // setSelectedDateFormat(formatDate(new Date()));
                          setSelectedDateID(new Date().getDay());
                          // setViewmoreslots(true);
                          setTodaymenuPopup(false);
                          updatemenuAvailablity("toggleTodaySlotOnOff", "", "");
                        }}
                        aria-label="checkedA"
                      />{" "}
                      <span
                        style={{
                          color: dayOnOff === true ? "greenyellow" : "red",
                          fontSize: "x-small",
                          marginLeft: "-8px",
                        }}
                      >
                        {dayOnOff === true ? "" : "OFF"}
                      </span>
                      {/* <i
                        onClick={() => {                        
                          menuPlanListREQ(formatDate(new Date()));
                          setSelectedDateName(
                            new Date().toLocaleDateString("en-us", {
                              weekday: "long"
                            }));
                          setSelectedDateFormat(formatDate(new Date()));
                          setSelectedDateID(new Date().getDay());
                          setViewmoreslots(true);
                        }}
                        style={{
                          fontSize: "small", color: "white", marginLeft: "18px"
                        }}
                        className="ti-eye"
                      ></i> */}
                      <i
                        onClick={() => {
                          let todayId = new Date().getDay();
                          let outletDate = formatDateYYMMDD(new Date());
                          viewTodaymenuMasterApiCall(todayId, outletDate);
                          //   menuPlanListREQ(formatDate(new Date()));
                          //   setSelectedDateName(
                          //     new Date().toLocaleDateString("en-us", {
                          //       weekday: "long"
                          //     }));
                          //   setSelectedDateFormat(formatDate(new Date()));
                          //   setSelectedDateID(new Date().getDay());
                          //   setViewmoreslots(true);
                          // let outletCode = adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
                          // let todayId = new Date().getDay();
                          // let outletDate = formatDateYYMMDD(new Date());
                          // window.open(`${FIS_BACKEND}/jasper/viewMenuByDayPDF?outletCode=${outletCode}&dayId=${todayId}&outletDate=${outletDate}`,
                          //   {
                          //     headers: authHeader()
                          //   });
                          // window.open(`${cp_url}?uid=${uid}&token=${token}`, '_blank');
                        }}
                        // href={functioncallforhref}
                        // href={`${FIS_BACKEND}/jasper/downloadMenuByDayPDF?outletCode=${adminToMangerOutletCode || outletCode}&dayId=${dayId}&outletDate=${outletDate}`}
                        // target="_blank"
                        style={{
                          fontSize: "small",
                          color: "white",
                          marginLeft: "18px",
                        }}
                        className="ti-eye"
                      ></i>
                      <i
                        onClick={() => {
                          let todayId = new Date().getDay();
                          let outletDate = formatDateYYMMDD(new Date());
                          downloadTodaymenuMasterApiCall(todayId, outletDate);
                        }}
                        style={{
                          fontSize: "small",
                          color: "white",
                          marginLeft: "18px",
                        }}
                        className="ti-download"
                      ></i>
                    </div>
                  )}
                </Card.Header>

                <Card.Body
                  onClick={() => {
                    if (!restarantvalue.value) {
                      alert("Please select Restarant");
                      return;
                      //  setSelectedMenuType("");
                      setTodaymenuPopup(false);
                    } else {
                      setSelectedDateName(
                        new Date().toLocaleDateString("en-us", {
                          weekday: "long",
                        })
                      );
                      setSelectedDateFormat(formatDate(new Date()));
                      setSelectedDateID(new Date().getDay());
                      setSelectedMenuType("today");
                      setTodaymenuPopup(true);
                      menuPlanListREQ(formatDate(new Date()));
                      // console.log(" setSelectedMenuType", setSelectedMenuType);
                      // console.log(" menuPlanListREQ", menuPlanListREQ);
                    }
                  }}
                >
                  <img
                    className="card-img-bottom img-fluid"
                    src={calendarlogo}
                    alt="Card cap"
                    style={{ width: "50%" }}
                  />
                </Card.Body>

                <Card.Footer>
                  <>
                    <h4>
                      {formatDate(new Date())}-
                      {new Date().toLocaleDateString("en-us", {
                        weekday: "long",
                      })}
                    </h4>
                  </>
                </Card.Footer>
              </Card>
            </Col>
            <Col xl="4">
              <Card className="">
                <Card.Header
                  style={{ backgroundColor: "green", color: "white" }}
                >
                  <Card.Title style={{ color: "white" }}>
                    {" "}
                    Tomorrow Menu
                  </Card.Title>

                  {/* {menuPlanList && menuPlanList.length > 0 && ( */}

                  {/* <div class="col-sm-6 col-md-5 col-xl-5 ">
                    <i
                      onClick={() => {
                        menuPlanListREQ(tomorrowId);
                        setSelectedDateName(tomorrowName);
                        setSelectedDateFormat(tomorrowId);
                        let dateschec = new Date();
                        dateschec.setDate(new Date().getDate() + 1);
                        setSelectedDateID(dateschec.getDay());
                        setViewmoreslots(true);
                        // eyeOnClickCardViewMoreSlot();
                      }}
                      style={{
                        fontSize: "small",
                        color: "white",
                        marginLeft: "18px",
                      }}
                      className="ti-eye"
                    ></i>
                  </div> */}

                  {/* )} */}
                </Card.Header>

                <Card.Body
                  onClick={async () => {
                    if (!restarantvalue.value) {
                      alert("Please Select Restarant");
                      return;
                      setTodaymenuPopup(false);
                    } else {
                      let dateschec = new Date();
                      dateschec.setDate(new Date().getDate() + 1);
                      await setSelectedDateFormat(formatDate(dateschec));
                      await setSelectedDateID(dateschec.getDay());
                      await setSelectedDateName(
                        dateschec.toLocaleDateString("en-us", {
                          weekday: "long",
                        })
                      );
                      await setTodaymenuPopup(true);
                      await setSelectedMenuType("Tomorrow");
                      await menuPlanListREQ(formatDate(dateschec));
                    }
                  }}
                >
                  <img
                    className="card-img-bottom img-fluid"
                    src={calendarlogo}
                    alt="Card cap"
                    style={{ width: "50%" }}
                  />
                </Card.Body>

                <Card.Footer>
                  <>
                    <h4>
                      {tomorrowId}-{tomorrowName}
                    </h4>
                  </>
                </Card.Footer>
              </Card>
            </Col>
            <Col xl="4">
              <Card
                className=""
                onClick={() => {
                  if (!restarantvalue.value) {
                    alert("Please Select Restarant");
                    return;
                    setTodaymenuPopup(false);
                  } else {
                    setTodaymenuPopup(true);
                    setSelectedMenuType("weekly");
                    setSelectedWeekType("currentweek");
                    weeekMasterApiCall("currentweek");
                  }
                }}
              >
                <Card.Header style={{ backgroundColor: "green" }}>
                  <Card.Title style={{ color: "white" }}>
                    {" "}
                    Weekly Menu
                  </Card.Title>
                </Card.Header>

                <Card.Body

                // onClick={() => {
                //   setTodaymenuPopup(true);
                //   setSelectedMenuType("weekly");
                // }}
                >
                  <img
                    className="card-img-bottom img-fluid"
                    src={calendarlogo}
                    alt="Card cap"
                    style={{ width: "50%" }}
                  />
                </Card.Body>

                <Card.Footer>
                  {/* <> */}
                  <h4>
                    From : {formatDate(new Date())} - To :{" "}
                    {formatDate(new Date(endofweek))}
                  </h4>
                  {/* </> */}
                </Card.Footer>
              </Card>
            </Col>
            {/* <div className="col-lg-12">
                 <Stepper
                  alternativeLabel
                  nonLinear
                  className="stepper-rtl"
                  activeStep={activeStep}
                 >
                 {steps.map((step, index) => {
                  const labelProps = {};
                  const stepProps = {};
                  if (isStepOptional(index)) {
                    labelProps.optional = (
                      <Typography
                        variant="caption"
                        align="center"
                        style={{ display: "block" }}
                      >
                        optional
                      </Typography>
                    );
                  }
                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={step} {...props}>
                      <StepButton
                        onClick={() => handleStep(index)}
                        {...stepProps}
                      >
                        {step}
                      </StepButton>
                    </Step>
                  );
                  })}
                 </Stepper>
                 <div className="pl-40">
                 <p>{getStepContent(activeStep)}</p>
                 </div>
                 </div> */}
          </>
        )}

        {todaymenuPopup === true && (
          <>
            {selectedMenuType == "weekly" && (
              <>
                <div className="row">
                  <div className="col-md-6">
                    <i
                      class="fas fa-arrow-left"
                      onClick={() => {
                        setArrowRightLeft(false);
                      }}
                      style={{
                        fontSize: "xxx-large",
                        color: !arrowRightLeft ? "grey" : "green",
                        paddingLeft: "465px",
                      }}
                    ></i>
                  </div>
                  <div className="col-md-6">
                    <i
                      class="fas fa-arrow-right"
                      onClick={() => {
                        setArrowRightLeft(true);
                      }}
                      style={{
                        fontSize: "xxx-large",
                        color: arrowRightLeft ? "grey" : "green",
                      }}
                    ></i>
                  </div>
                </div>
                <br /> <n />
                {(selectedWeekType == "pastWeek" ||
                  selectedWeekType == "currentweek" ||
                  selectedWeekType == "nextweek") &&
                  (weeklyMenuMasterOfPastCurrentNextWeeks &&
                  weeklyMenuMasterOfPastCurrentNextWeeks.length > 0
                    ? weeklyMenuMasterOfPastCurrentNextWeeks.map(
                        (items, initialindex) => {
                          // console.log("items", items)   // console.log("initialindex", initialindex)
                          let addvalue = initialindex + 1;
                          return (
                            <Col xl="3">
                              {!arrowRightLeft && initialindex <= 3 && (
                                <>
                                  <br />
                                  <Card
                                    className=""
                                    // style={{ maxWidth: "fitcontent" }}
                                    // onClick={() => {
                                    //   setSelectedDateName(items['dayName']);
                                    //   setSelectedDateFormat(items['outletDate']);
                                    //   setSelectedDateID(items['dayId']);
                                    //   setSelectedMenuType("today");
                                    //   menuPlanListREQ(items['outletDate']);
                                    // }}
                                  >
                                    <Card.Header
                                      style={{ backgroundColor: "green" }}
                                    >
                                      <Card.Title
                                        style={{
                                          color: "white",
                                          fontSize: "small",
                                        }}
                                      >
                                        {" "}
                                        {items["outletDate"]} -{` `}{" "}
                                        <span>{items["dayName"]}</span>
                                        <br />
                                        {/* {console.log("initialindex[initialindex]", weeklyMenuMasterOfPastCurrentNextWeeks[initialindex])}
                                {console.log("addvalue[initialindex]", weeklyMenuMasterOfPastCurrentNextWeeks[addvalue])}
                                {console.log("slotList[slotList]", weeklyMenuMasterOfPastCurrentNextWeeks[addvalue]?.slotList)} */}
                                        {selectedWeekType != "pastWeek" &&
                                        weeklyMenuMasterOfPastCurrentNextWeeks[
                                          initialindex
                                        ]?.slotList &&
                                        weeklyMenuMasterOfPastCurrentNextWeeks[
                                          initialindex
                                        ]?.slotList.length >= 0 &&
                                        weeklyMenuMasterOfPastCurrentNextWeeks[
                                          addvalue
                                        ]?.slotList == null ? (
                                          <>
                                            <span
                                              style={{ fontSize: "x-small" }}
                                              onClick={() => {
                                                copytonext(initialindex);
                                              }}
                                            >
                                              copy menu to next day {` `}
                                            </span>
                                            <i
                                              class="fas fa-arrow-right"
                                              style={{
                                                fontSize: "large",
                                                color: "white",
                                              }}
                                              onClick={() => {
                                                copytonext(initialindex);
                                              }}
                                            >
                                              {" "}
                                            </i>
                                          </>
                                        ) : (
                                          <br />
                                        )}
                                      </Card.Title>

                                      <i
                                        onClick={() => {
                                          // if (viewmoreslots === true) {
                                          setSelectedDateName(items["dayName"]);
                                          setSelectedDateFormat(
                                            items["outletDate"]
                                          );
                                          setSelectedDateID(items["dayId"]);
                                          setSelectedMenuType("today");
                                          menuPlanListREQ(items["outletDate"]);
                                          // }
                                        }}
                                        style={{
                                          fontSize: "small",
                                          color: "white",
                                        }}
                                        className="ti-pencil"
                                      ></i>

                                      {items.slotList && (
                                        <>
                                          {/* <i
                                          onClick={() => {
                                            setViewmoreslots(true);
                                            setSelectedViewMoreslotsDetails(items.slotList);
                                            setSelectedMenuType("weekly");
                                            setSelectedDateName(items["dayName"]);
                                            setSelectedDateFormat(items["outletDate"]);
                                            setSelectedDateID(items["dayId"]);
                                            menuPlanListREQ(items["outletDate"]);
                                          }}
                                          style={{ fontSize: "small", color: "white" }}
                                          className="ti-eye"
                                        ></i> */}

                                          <i
                                            onClick={() => {
                                              let todayId = items["dayId"];
                                              var dateString =
                                                items["outletDate"];
                                              var dateParts =
                                                dateString.split("/");
                                              var dateObject = new Date(
                                                +dateParts[2],
                                                dateParts[1] - 1,
                                                +dateParts[0]
                                              );
                                              // document.body.innerHTML = dateObject.toString();
                                              let somethi =
                                                dateObject.toString();
                                              let somethinewDate = new Date(
                                                somethi
                                              );
                                              let setdate2 =
                                                somethinewDate.getFullYear() +
                                                "-" +
                                                (somethinewDate.getMonth() +
                                                  1) +
                                                "-" +
                                                somethinewDate.getDate();
                                              viewTodaymenuMasterApiCall(
                                                todayId,
                                                setdate2
                                              );
                                            }}
                                            style={{
                                              fontSize: "small",
                                              color: "white",
                                            }}
                                            className="ti-eye"
                                          ></i>

                                          <i
                                            onClick={() => {
                                              let todayId = items["dayId"];
                                              var dateString =
                                                items["outletDate"];
                                              var dateParts =
                                                dateString.split("/");
                                              var dateObject = new Date(
                                                +dateParts[2],
                                                dateParts[1] - 1,
                                                +dateParts[0]
                                              );
                                              // document.body.innerHTML = dateObject.toString();
                                              let somethi =
                                                dateObject.toString();
                                              let somethinewDate = new Date(
                                                somethi
                                              );
                                              let setdate2 =
                                                somethinewDate.getFullYear() +
                                                "-" +
                                                (somethinewDate.getMonth() +
                                                  1) +
                                                "-" +
                                                somethinewDate.getDate();
                                              downloadTodaymenuMasterApiCall(
                                                todayId,
                                                setdate2
                                              );
                                            }}
                                            style={{
                                              fontSize: "small",
                                              color: "white",
                                            }}
                                            className="ti-download"
                                          ></i>
                                        </>
                                      )}
                                    </Card.Header>
                                    <Card.Body>
                                      {items.slotList &&
                                        items.slotList.map((items2, index) => {
                                          //
                                          // console.log("items2test123", items2)
                                          // console.log("items2test", index)
                                          // if (index == 0 || index == 1) {
                                          // if (index <= 4) {
                                          return (
                                            <Card
                                              className=""
                                              // style={{ maxWidth: "fit-content", height: "137px" }}
                                              // style={{ height: "137px" }}
                                              style={{ height: "fit-content" }}
                                              // onClick={() => { }}
                                            >
                                              <Card.Header
                                                style={{
                                                  backgroundColor: "#4da74d",
                                                  height: "27px",
                                                }}
                                              >
                                                <Card.Title
                                                  style={{ color: "white" }}
                                                >
                                                  {" "}
                                                  {items2?.slotName}
                                                </Card.Title>
                                              </Card.Header>
                                              <Card.Body
                                              // style={{ maxWidth: "fit-content" }}
                                              >
                                                {items2?.itemList &&
                                                  items2?.itemList.map(
                                                    (items3, index3) => {
                                                      return (
                                                        <h6>
                                                          {" "}
                                                          {
                                                            items3?.menuName
                                                          }{" "}
                                                        </h6>
                                                      );
                                                      // if (index3 == 0) {
                                                      //   return `${items3?.menuName && items3?.menuName.slice(
                                                      //     0, 10)}..`;
                                                      // }
                                                    }
                                                  )}
                                              </Card.Body>
                                              <n /> <n />
                                              {/* {items.slotList && items.slotList.length >= 0 &&
                                        <p style={{ color: "blue", marginLeft: "26px" }}
                                          onClick={() => {
                                            setViewmoreslots(true);
                                            setSelectedViewMoreslotsDetails(items.slotList);
                                            setSelectedMenuType("weekly");
                                            setSelectedDateName(items['dayName']);
                                            setSelectedDateFormat(items['outletDate']);
                                            setSelectedDateID(items['dayId']);
                                            menuPlanListREQ(items['outletDate']);
                                          }}
                                        > View more slots </p>} */}
                                            </Card>
                                          );
                                          // }
                                        })}
                                      {(items.slotList == null ||
                                        (items.slotList &&
                                          items.slotList.length <= 0)) &&
                                        "No slots available for the day"}
                                    </Card.Body>
                                  </Card>
                                </>
                              )}
                              {arrowRightLeft && initialindex > 3 && (
                                <>
                                  <br />
                                  <Card
                                    className=""
                                    // onClick={() => {
                                    //   setSelectedDateName(items['dayName']);
                                    //   setSelectedDateFormat(items['outletDate']);
                                    //   setSelectedDateID(items['dayId']);
                                    //   setSelectedMenuType("today");
                                    //   menuPlanListREQ(items['outletDate']);
                                    // }}
                                  >
                                    <Card.Header
                                      style={{ backgroundColor: "green" }}
                                    >
                                      <Card.Title
                                        style={{
                                          color: "white",
                                          fontSize: "small",
                                        }}
                                      >
                                        {" "}
                                        {items["outletDate"]} -{` `}{" "}
                                        <span>{items["dayName"]}</span>
                                        <br />
                                        {/* {console.log("initialindex[initialindex]", weeklyMenuMasterOfPastCurrentNextWeeks[initialindex])}
                                {console.log("addvalue[initialindex]", weeklyMenuMasterOfPastCurrentNextWeeks[addvalue])}
                                {console.log("slotList[slotList]", weeklyMenuMasterOfPastCurrentNextWeeks[addvalue]?.slotList)} */}
                                        {selectedWeekType != "pastWeek" &&
                                        weeklyMenuMasterOfPastCurrentNextWeeks[
                                          initialindex
                                        ]?.slotList &&
                                        weeklyMenuMasterOfPastCurrentNextWeeks[
                                          initialindex
                                        ]?.slotList.length >= 0 &&
                                        weeklyMenuMasterOfPastCurrentNextWeeks[
                                          addvalue
                                        ]?.slotList == null ? (
                                          <>
                                            <span
                                              style={{ fontSize: "x-small" }}
                                              onClick={() => {
                                                copytonext(initialindex);
                                              }}
                                            >
                                              copy menu to next day {` `}
                                            </span>
                                            <i
                                              class="fas fa-arrow-right"
                                              style={{
                                                fontSize: "large",
                                                color: "white",
                                              }}
                                              onClick={() => {
                                                copytonext(initialindex);
                                              }}
                                            >
                                              {" "}
                                            </i>
                                          </>
                                        ) : (
                                          <br />
                                        )}
                                      </Card.Title>

                                      <i
                                        onClick={() => {
                                          // if (viewmoreslots === true) {
                                          setSelectedDateName(items["dayName"]);
                                          setSelectedDateFormat(
                                            items["outletDate"]
                                          );
                                          setSelectedDateID(items["dayId"]);
                                          setSelectedMenuType("today");
                                          menuPlanListREQ(items["outletDate"]);
                                          // }
                                        }}
                                        style={{
                                          fontSize: "small",
                                          color: "white",
                                        }}
                                        className="ti-pencil"
                                      ></i>

                                      {items.slotList && (
                                        <>
                                          {/* <i
                                          onClick={() => {
                                            setViewmoreslots(true);
                                            setSelectedViewMoreslotsDetails(items.slotList);
                                            setSelectedMenuType("weekly");
                                            setSelectedDateName(items["dayName"]);
                                            setSelectedDateFormat(items["outletDate"]);
                                            setSelectedDateID(items["dayId"]);
                                            menuPlanListREQ(items["outletDate"]);
                                          }}
                                          style={{ fontSize: "small", color: "white" }}
                                          className="ti-eye"
                                        ></i> */}

                                          <i
                                            onClick={() => {
                                              let todayId = items["dayId"];
                                              var dateString =
                                                items["outletDate"];
                                              var dateParts =
                                                dateString.split("/");
                                              var dateObject = new Date(
                                                +dateParts[2],
                                                dateParts[1] - 1,
                                                +dateParts[0]
                                              );
                                              // document.body.innerHTML = dateObject.toString();
                                              let somethi =
                                                dateObject.toString();
                                              let somethinewDate = new Date(
                                                somethi
                                              );
                                              let setdate2 =
                                                somethinewDate.getFullYear() +
                                                "-" +
                                                (somethinewDate.getMonth() +
                                                  1) +
                                                "-" +
                                                somethinewDate.getDate();
                                              viewTodaymenuMasterApiCall(
                                                todayId,
                                                setdate2
                                              );
                                            }}
                                            style={{
                                              fontSize: "small",
                                              color: "white",
                                            }}
                                            className="ti-eye"
                                          ></i>

                                          <i
                                            onClick={() => {
                                              let todayId = items["dayId"];
                                              var dateString =
                                                items["outletDate"];
                                              var dateParts =
                                                dateString.split("/");
                                              var dateObject = new Date(
                                                +dateParts[2],
                                                dateParts[1] - 1,
                                                +dateParts[0]
                                              );
                                              // document.body.innerHTML = dateObject.toString();
                                              let somethi =
                                                dateObject.toString();
                                              let somethinewDate = new Date(
                                                somethi
                                              );
                                              let setdate2 =
                                                somethinewDate.getFullYear() +
                                                "-" +
                                                (somethinewDate.getMonth() +
                                                  1) +
                                                "-" +
                                                somethinewDate.getDate();
                                              downloadTodaymenuMasterApiCall(
                                                todayId,
                                                setdate2
                                              );
                                            }}
                                            style={{
                                              fontSize: "small",
                                              color: "white",
                                            }}
                                            className="ti-download"
                                          ></i>
                                        </>
                                      )}
                                    </Card.Header>
                                    <Card.Body>
                                      {items.slotList &&
                                        items.slotList.map((items2, index) => {
                                          //
                                          // console.log("items2test123", items2)
                                          // console.log("items2test", index)
                                          // if (index == 0 || index == 1) {
                                          // if (index <= 4) {
                                          return (
                                            <Card
                                              className=""
                                              // style={{ height: "137px" }}
                                              style={{ height: "fit-content" }}
                                              onClick={() => {}}
                                            >
                                              <Card.Header
                                                style={{
                                                  backgroundColor: "#4da74d",
                                                  height: "27px",
                                                }}
                                              >
                                                <Card.Title
                                                  style={{ color: "white" }}
                                                >
                                                  {" "}
                                                  {items2?.slotName}
                                                </Card.Title>
                                              </Card.Header>
                                              <Card.Body>
                                                {/* {items2?.itemList && items2?.itemList.map(
                                                (items3, index3) => {
                                                  if (index3 == 0) {
                                                    return `${items3?.menuName && items3?.menuName.slice(
                                                      0, 10)}..`;
                                                  }
                                                }
                                              )} */}
                                                {items2?.itemList &&
                                                  items2?.itemList.map(
                                                    (items3, index3) => {
                                                      return (
                                                        <h6>
                                                          {" "}
                                                          {
                                                            items3?.menuName
                                                          }{" "}
                                                        </h6>
                                                      );
                                                    }
                                                  )}
                                              </Card.Body>
                                              <n /> <n />
                                              {/* {items.slotList && items.slotList.length >= 0 &&
                                        <p style={{ color: "blue", marginLeft: "26px" }}
                                          onClick={() => {
                                            setViewmoreslots(true);
                                            setSelectedViewMoreslotsDetails(items.slotList);
                                            setSelectedMenuType("weekly");
                                            setSelectedDateName(items['dayName']);
                                            setSelectedDateFormat(items['outletDate']);
                                            setSelectedDateID(items['dayId']);
                                            menuPlanListREQ(items['outletDate']);
                                          }}
                                        > View more slots </p>} */}
                                            </Card>
                                          );
                                          // }
                                        })}
                                      {(items.slotList == null ||
                                        (items.slotList &&
                                          items.slotList.length <= 0)) &&
                                        "No slots available for the day"}
                                    </Card.Body>
                                  </Card>
                                </>
                              )}
                            </Col>
                          );
                        }
                      )
                    : "No Menu List Available for the day")}
                <div className="col-lg-12">
                  {/* <Table responsive style={{ width: "100%" }}>
                    <thead style={{ backgroundColor: "green" }}>
                      <tr>
                        {weeklymenu && weeklymenu.map((items) => {
                          return <th style={{ border: "1px solid" }}>
                            <strong>{items['outletDate']}</strong>
                            <br />
                            <span>{items['dayName']}</span>
                            <br />
                            <span style={{ fontSize: "x-small" }}>copy to next day</span>  <i class="fas fa-arrow-right">  </i>
                          </th>
                        })}
                      </tr> </thead>
                  </Table> */}

                  {/* {weeklymenu && weeklymenu.map((items) => {
                  return <div className="row">
                    {items.slotOfDay.map((items) => {
                      return <div className="col-md-2">
                        <div className="card">
                          <div className="card-header border-0">
                            <div>
                              <h4 className="fs-20 mb-1"> {items?.slotName}</h4>
                            </div>
                          </div>
                          <div className="card-body pb-0">
                            {items?.categorySubCategoryList.map((item) => (
                              <div className="d-flex pb-3 mb-3 tr-row align-items-center border-bottom">
                                <div className="me-auto pe-3">
                                  <h2 className="text-black fs-14 font-w600">{item.menuName}</h2>
                                </div>
                              </div>
                            ))}
                          </div>

                        </div>
                      </div>
                    })}
                  </div>
                })
                } */}

                  {/* <div className="row">
                  {weeklymenu && weeklymenu.map((items) => {
                    return items.slotOfDay.map((items) => {
                      return <div className="col-md-2">
                        <div className="card">
                          <div className="card-header border-0">
                            <div>
                              <h4 className="fs-20 mb-1"> {items?.slotName}</h4>
                            </div>
                          </div>
                          <div className="card-body pb-0">
                            {items?.categorySubCategoryList.map((item) => (
                              <div className="d-flex pb-3 mb-3 tr-row align-items-center border-bottom">
                                <div className="me-auto pe-3">
                                  <h2 className="text-black fs-14 font-w600">{item.menuName}</h2>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    })
                  })
                  }
                </div> */}

                  {/* <div className="row">
                    {weeklymenu && weeklymenu.map((items1) => {
                      return <div className="col-md-2">
                        <h5>{items1?.dayName} </h5>
                        {items1.slotOfDay.map((items2) => {
                          return <h5> {items2?.slotName}
                            {items2?.categorySubCategoryList.map((items3) => {
                              return <h5> {items3?.menuName} </h5>
                            })
                            }
                          </h5>
                        })}
                      </div>
                    })}
                  </div> */}

                  {/* <div className="row">
                  {weeklymenu && weeklymenu.map((items1) => {
                    return <div className="col-md-2">
                      {items1.slotOfDay.map((items2) => {
                        return <div className="card">
                          <div className="card-header border-0">
                            {items2?.slotName}
                          </div>  </div>
                        {/* <div>
                              <h4 className="fs-20 mb-1"> {items2?.slotName}</h4>
                            </div> */}
                  {/* {items2?.slotName} */}
                  {/* {items2?.categorySubCategoryList.map((items3) => {
                              return <h4> {items3?.menuName} </h4>
                            })
                            } */}
                  {/* })}
                    </div>
                  })}
                </div> */}
                </div>
              </>
            )}

            {selectedMenuType == "today" && (
              <div className="todays-menu-con">
                <div className="row">
                  {menuPlanList &&
                    menuPlanList.map((mainItem) => {
                      return (
                        <Col xl="11">
                          <Card className="">
                            <Card.Header
                              style={{
                                backgroundColor:
                                  mainItem?.slotFlag == "ON"
                                    ? "#0a5c0a"
                                    : "grey",
                              }}
                            >
                              <Card.Title style={{ color: "white" }}>
                                {mainItem?.slotName} - {mainItem?.slotStartTime}{" "}
                                - {mainItem?.slotEndTime}
                              </Card.Title>
                              {/* <div class="col-sm-6 col-md-5 col-xl-5"> */}

                              {selectedWeekType != "pastWeek" && (
                                <>
                                  <div>
                                    <i
                                      onClick={() => {
                                        let todayId = mainItem["dayId"];
                                        let slotId = mainItem["slotId"];
                                        var dateString = mainItem["outletDate"];
                                        var dateParts = dateString.split("/");
                                        var dateObject = new Date(
                                          +dateParts[2],
                                          dateParts[1] - 1,
                                          +dateParts[0]
                                        );
                                        let somethi = dateObject.toString();
                                        let somethinewDate = new Date(somethi);
                                        let outletDate =
                                          somethinewDate.getFullYear() +
                                          "-" +
                                          (somethinewDate.getMonth() + 1) +
                                          "-" +
                                          somethinewDate.getDate();
                                        viewTodaymenuSlotwiseApiCall(
                                          todayId,
                                          slotId,
                                          outletDate
                                        );
                                      }}
                                      style={{
                                        fontSize: "small",
                                        color: "white",
                                        marginRight: "23px",
                                      }}
                                      className="ti-eye"
                                    ></i>

                                    <i
                                      onClick={() => {
                                        let todayId = mainItem["dayId"];
                                        let slotId = mainItem["slotId"];
                                        var dateString = mainItem["outletDate"];
                                        var dateParts = dateString.split("/");
                                        var dateObject = new Date(
                                          +dateParts[2],
                                          dateParts[1] - 1,
                                          +dateParts[0]
                                        );
                                        let somethi = dateObject.toString();
                                        let somethinewDate = new Date(somethi);
                                        let outletDate =
                                          somethinewDate.getFullYear() +
                                          "-" +
                                          (somethinewDate.getMonth() + 1) +
                                          "-" +
                                          somethinewDate.getDate();
                                        slotWisedownloadTodaymenuMasterApiCall(
                                          todayId,
                                          slotId,
                                          outletDate
                                        );
                                      }}
                                      style={{
                                        fontSize: "small",
                                        color: "white",
                                        marginRight: "18px",
                                      }}
                                      className="ti-download"
                                    ></i>

                                    <Switch
                                      checked={mainItem?.slotFlag == "ON"}
                                      style={{
                                        color:
                                          mainItem?.slotFlag == "ON"
                                            ? "green"
                                            : "red",
                                      }}
                                      aria-label="checkedA"
                                      onChange={() => {
                                        setMenuPlanList(
                                          menuPlanList.map((items) => ({
                                            ...items,
                                            slotId:
                                              items?.slotId ==
                                                mainItem?.slotId &&
                                              items?.slotFlag == "ON"
                                                ? {
                                                    ...(items["slotFlag"] =
                                                      "OFF"),
                                                  }
                                                : {
                                                    ...(items["slotFlag"] =
                                                      "ON"),
                                                  },
                                          }))
                                        );
                                        updatemenuAvailablity(
                                          "slotOnOff",
                                          mainItem,
                                          ""
                                        );
                                      }}
                                    />
                                    <span
                                      style={{
                                        color:
                                          mainItem?.slotFlag == "ON"
                                            ? "green"
                                            : "red",
                                        fontSize: "x-small",
                                        marginLeft: "-8px",
                                      }}
                                    >
                                      {" "}
                                      {mainItem?.slotFlag == "ON" ? "" : ""}
                                    </span>
                                  </div>
                                </>
                              )}
                            </Card.Header>
                            <Card.Body>
                              <Table responsive style={{ width: "100%" }}>
                                {/* <thead style={{ backgroundColor: "#2d8112" }}>  */}
                                <thead
                                  style={{
                                    backgroundColor:
                                      mainItem?.slotFlag == "ON"
                                        ? "#0a5c0a"
                                        : "grey",
                                  }}
                                >
                                  <tr>
                                    <th>
                                      <strong>IMAGE</strong>
                                    </th>

                                    <th>
                                      <strong>NAME </strong>
                                    </th>

                                    <th>
                                      <strong>PRICE ₹ </strong>
                                    </th>

                                    <th>
                                      <strong>MAIN CATEGORY</strong>
                                    </th>
                                    <th>
                                      {" "}
                                      <strong>MENU ID</strong>
                                    </th>
                                    <th>
                                      <strong>SUB CATEGORY</strong>
                                    </th>
                                    <th>
                                      <strong>PLAN ID</strong>
                                    </th>
                                    <th>
                                      <strong>PLAN NAME</strong>
                                    </th>
                                    <th>
                                      <strong>AVAILABLITY</strong>
                                    </th>

                                    <th>
                                      <strong>ACTION</strong>
                                    </th>
                                  </tr>
                                </thead>
                                {/* <div className="input-group search-area"> */}
                                <br />
                                {/* <input type="text" className="form-control"
                              onClick={() => onAddUpdateUserModalClose()}
                              placeholder="Search Item" /> */}

                                {/* <div class="col-sm col-md-4 form-group">
                              <label
                                as="a"
                                variant="badge badge-rounded badge-danger"
                              >
                                Food Item
                              </label> */}
                                {/* </div> */}

                                {mainItem?.itemList
                                  ? mainItem?.itemList.map((subItem) => {
                                      // console.log("subItem subItem",subItem);
                                      return (
                                        <tr>
                                          <td>
                                            <img
                                              className="me-3 img-fluid"
                                              src={subItem.itemPath}
                                              width="50px"
                                              alt="DexignZone"
                                            />
                                          </td>
                                          <td>{subItem.menuName}</td>
                                          <td>{subItem.price}</td>

                                          <td>{subItem.mainMenuName}</td>
                                          <td>{subItem.menuId}</td>

                                          <td>{subItem.subMenuName}</td>
                                          <td>{subItem.planId}</td>
                                          <td>{subItem.planName}</td>
                                          <td>
                                            {selectedWeekType != "pastWeek" &&
                                              mainItem?.slotFlag == "ON" && (
                                                <div class="col-sm-6 col-md-5 col-xl-5 ">
                                                  <Switch
                                                    checked={
                                                      subItem?.itemFlag == "ON"
                                                    }
                                                    style={{
                                                      color:
                                                        subItem?.itemFlag ==
                                                        "ON"
                                                          ? "green"
                                                          : "red",
                                                    }}
                                                    onChange={() => {
                                                      setPriceAmountOfItem(
                                                        subItem?.price
                                                      );
                                                      // console.log("item?.slotId", subItem?.slotId);

                                                      setMenuPlanList(
                                                        menuPlanList.map(
                                                          (items) => ({
                                                            ...items,
                                                            itemList:
                                                              items.itemList.map(
                                                                (object1) => {
                                                                  return object1?.itemFlag ==
                                                                    "ON"
                                                                    ? {
                                                                        ...(object1[
                                                                          "itemFlag"
                                                                        ] =
                                                                          "OFF"),
                                                                      }
                                                                    : {
                                                                        ...(object1[
                                                                          "itemFlag"
                                                                        ] =
                                                                          "ON"),
                                                                      };
                                                                }
                                                              ),
                                                          })
                                                        )
                                                      );
                                                      updatemenuAvailablity(
                                                        "foodItemUpdate",
                                                        mainItem,
                                                        subItem
                                                      );
                                                    }}
                                                    aria-label="checkedA"
                                                  />{" "}
                                                  <span
                                                    style={{
                                                      color:
                                                        subItem?.itemFlag ==
                                                        "ON"
                                                          ? "green"
                                                          : "red",
                                                      fontSize: "x-small",
                                                      // marginLeft: "-8px"
                                                    }}
                                                  >
                                                    {(dayOnOff === false
                                                      ? "day off"
                                                      : "") ||
                                                      (subItem?.itemFlag == "ON"
                                                        ? ""
                                                        : "Out of Stock")}
                                                  </span>
                                                </div>
                                              )}
                                          </td>
                                          <td>
                                            {selectedWeekType != "pastWeek" &&
                                              mainItem?.slotFlag == "ON" && (
                                                <>
                                                  <Link
                                                    to={"#"}
                                                    onClick={() => {
                                                      // console.log("item?.slotId", subItem?.slotId);
                                                      // updatemenuAvailablity("deleteItem", mainItem, subItem);
                                                      SetUpdatemenuAvailablitymainItem(
                                                        mainItem
                                                      );
                                                      SetUpdatemenuAvailablitysubItem(
                                                        subItem
                                                      );
                                                      onRejectClose();
                                                    }}
                                                    className="ti-close fs-28 text-danger las la-times-circle"
                                                  ></Link>

                                                  <Link
                                                    to={"#"}
                                                    onClick={() => {
                                                      //
                                                      // console.log("1s");
                                                      // console.log(
                                                      //   "mainItem",
                                                      //   mainItem
                                                      // );
                                                      // console.log(
                                                      //   "subItem",
                                                      //   subItem
                                                      // );

                                                      setEditmenuavailablity(
                                                        true
                                                      );
                                                      const newFormData = {
                                                        ...menuAvailablitMaster,
                                                      };
                                                      newFormData["menuId"] =
                                                        subItem?.menuId;
                                                      newFormData[
                                                        "mainMenuId"
                                                      ] = subItem?.mainMenuId;
                                                      newFormData["subMenuId"] =
                                                        subItem?.subMenuId;
                                                      newFormData["uom"] =
                                                        subItem?.uom;

                                                      // newFormData["slotId"] = [mainItem?.slotId];
                                                      setMenuAvailablitMaster(
                                                        newFormData
                                                      );
                                                      const newFormData1 = {
                                                        ...selectedSlotTiming,
                                                      };
                                                      // newFormData1["label"] = mainItem?.slotName;
                                                      newFormData1["label"] = (
                                                        <div>
                                                          {" "}
                                                          {
                                                            mainItem?.slotName
                                                          } -{" "}
                                                          {
                                                            mainItem?.slotStartTime
                                                          }{" "}
                                                          -{" "}
                                                          {
                                                            mainItem?.slotEndTime
                                                          }{" "}
                                                        </div>
                                                      );
                                                      newFormData1["value"] =
                                                        mainItem?.slotId;

                                                      setSelectedSlotTiming([
                                                        newFormData1,
                                                      ]);

                                                      setSelectedslotmaster({
                                                        label:
                                                          mainItem?.slotName,
                                                        value: mainItem?.slotId,
                                                      });

                                                      setPriceAmountOfItem(
                                                        subItem?.price
                                                      );
                                                      setQuanitytyOfItem(
                                                        subItem?.quantity
                                                      );

                                                      onAddUpdateUserModalClose();
                                                      // console.log(
                                                      //   "item?.slotId",
                                                      //   subItem?.slotId
                                                      // );

                                                      setSelectedMenuItem({
                                                        label:
                                                          subItem?.menuName,
                                                        value: subItem?.menuId,
                                                      });

                                                      setSelectedcategoryMaster(
                                                        {
                                                          label:
                                                            subItem?.mainMenuName,
                                                          value:
                                                            subItem?.mainMenuId,
                                                        }
                                                      );

                                                      setSelectedsubcategoryMaster(
                                                        {
                                                          label:
                                                            subItem?.subMenuName,
                                                          value:
                                                            subItem?.subMenuId,
                                                        }
                                                      );
                                                    }}
                                                    className="ti-pencil fs-20 text-success"
                                                  ></Link>
                                                </>
                                              )}
                                          </td>
                                        </tr>
                                      );
                                    })
                                  : "No Data Available for the day"}
                              </Table>
                            </Card.Body>
                          </Card>
                        </Col>
                      );
                    })}{" "}
                  {menuPlanList && menuPlanList.length === 0 && (
                    <>
                      <br />
                      <h4 style={{ color: "green", marginLeft: "439px" }}>
                        No slots available for the day
                        <i
                          style={{ fontSize: "x-large", color: "red" }}
                          className="ti-alert"
                        ></i>
                      </h4>
                    </>
                  )}
                </div>
              </div>
            )}

            {selectedMenuType == "Tomorrow" && (
              <div className="todays-menu-con">
                <div className="row">
                  {menuPlanList &&
                    menuPlanList.map((mainItem) => {
                      return (
                        <Col xl="11">
                          <Card className="">
                            <Card.Header
                              style={{
                                backgroundColor:
                                  mainItem?.slotFlag == "ON"
                                    ? "#0a5c0a"
                                    : "grey",
                              }}
                            >
                              <Card.Title style={{ color: "white" }}>
                                {mainItem?.slotName} - {mainItem?.slotStartTime}{" "}
                                - {mainItem?.slotEndTime}
                              </Card.Title>
                              {/* <div class="col-sm-6 col-md-5 col-xl-5"> */}
                              <div>
                                <i
                                  onClick={() => {
                                    let todayId = mainItem["dayId"];
                                    let slotId = mainItem["slotId"];
                                    var dateString = mainItem["outletDate"];
                                    var dateParts = dateString.split("/");
                                    var dateObject = new Date(
                                      +dateParts[2],
                                      dateParts[1] - 1,
                                      +dateParts[0]
                                    );
                                    let somethi = dateObject.toString();
                                    let somethinewDate = new Date(somethi);
                                    let outletDate =
                                      somethinewDate.getFullYear() +
                                      "-" +
                                      (somethinewDate.getMonth() + 1) +
                                      "-" +
                                      somethinewDate.getDate();
                                    viewTodaymenuSlotwiseApiCall(
                                      todayId,
                                      slotId,
                                      outletDate
                                    );
                                  }}
                                  style={{
                                    fontSize: "small",
                                    color: "white",
                                    marginRight: "23px",
                                  }}
                                  className="ti-eye"
                                ></i>

                                <i
                                  onClick={() => {
                                    let todayId = mainItem["dayId"];
                                    let slotId = mainItem["slotId"];
                                    var dateString = mainItem["outletDate"];
                                    var dateParts = dateString.split("/");
                                    var dateObject = new Date(
                                      +dateParts[2],
                                      dateParts[1] - 1,
                                      +dateParts[0]
                                    );
                                    let somethi = dateObject.toString();
                                    let somethinewDate = new Date(somethi);
                                    let outletDate =
                                      somethinewDate.getFullYear() +
                                      "-" +
                                      (somethinewDate.getMonth() + 1) +
                                      "-" +
                                      somethinewDate.getDate();
                                    slotWisedownloadTodaymenuMasterApiCall(
                                      todayId,
                                      slotId,
                                      outletDate
                                    );
                                  }}
                                  style={{
                                    fontSize: "small",
                                    color: "white",
                                    marginRight: "18px",
                                  }}
                                  className="ti-download"
                                ></i>

                                <Switch
                                  checked={mainItem?.slotFlag == "ON"}
                                  style={{
                                    color:
                                      mainItem?.slotFlag == "ON"
                                        ? "green"
                                        : "red",
                                  }}
                                  aria-label="checkedA"
                                  onChange={() => {
                                    setMenuPlanList(
                                      menuPlanList.map((items) => ({
                                        ...items,
                                        slotId:
                                          items?.slotId == mainItem?.slotId &&
                                          items?.slotFlag == "ON"
                                            ? { ...(items["slotFlag"] = "OFF") }
                                            : { ...(items["slotFlag"] = "ON") },
                                      }))
                                    );
                                    updatemenuAvailablity(
                                      "slotOnOff",
                                      mainItem,
                                      ""
                                    );
                                  }}
                                />
                                <span
                                  style={{
                                    color:
                                      mainItem?.slotFlag == "ON"
                                        ? "green"
                                        : "red",
                                    fontSize: "x-small",
                                    marginLeft: "-8px",
                                  }}
                                >
                                  {" "}
                                  {mainItem?.slotFlag == "ON" ? "" : ""}
                                </span>
                              </div>
                            </Card.Header>
                            <Card.Body>
                              <Table responsive style={{ width: "100%" }}>
                                {/* <thead style={{ backgroundColor: "#2d8112" }}>  */}
                                <thead
                                  style={{
                                    backgroundColor:
                                      mainItem?.slotFlag == "ON"
                                        ? "#0a5c0a"
                                        : "grey",
                                  }}
                                >
                                  <tr>
                                    <th>
                                      <strong>IMAGE</strong>
                                    </th>

                                    <th>
                                      <strong>NAME </strong>
                                    </th>

                                    <th>
                                      <strong>PRICE ₹ </strong>
                                    </th>

                                    <th>
                                      <strong>MAIN CATEGORY</strong>
                                    </th>

                                    <th>
                                      <strong>SUB CATEGORY</strong>
                                    </th>

                                    <th>
                                      <strong>PLAN ID</strong>
                                    </th>

                                    <th>
                                      <strong>PLAN NAME</strong>
                                    </th>

                                    <th>
                                      <strong>AVAILABLITY</strong>
                                    </th>

                                    <th>
                                      <strong>ACTION</strong>
                                    </th>
                                  </tr>
                                </thead>
                                {/* <div className="input-group search-area"> */}
                                <br />
                                {/* <input type="text" className="form-control"
                              onClick={() => onAddUpdateUserModalClose()}
                              placeholder="Search Item" /> */}

                                {/* <div class="col-sm col-md-4 form-group">
                              <label
                                as="a"
                                variant="badge badge-rounded badge-danger"
                              >
                                Food Item
                              </label> */}
                                {/* </div> */}

                                {mainItem?.itemList &&
                                  mainItem?.itemList.map((subItem) => {
                                    return (
                                      <tr>
                                        <td>
                                          <img
                                            className="me-3 img-fluid"
                                            src={subItem.itemPath}
                                            width="50px"
                                            alt="DexignZone"
                                          />
                                        </td>
                                        <td>{subItem.menuName}</td>
                                        <td>{subItem.price}</td>

                                        <td>{subItem.mainMenuName}</td>
                                        <td>{subItem.subMenuName}</td>
                                        <td>{subItem.planId}</td>
                                        <td>{subItem.planName}</td>
                                        <td>
                                          {mainItem?.slotFlag == "ON" && (
                                            <div class="col-sm-6 col-md-5 col-xl-5 ">
                                              <Switch
                                                checked={
                                                  subItem?.itemFlag == "ON"
                                                }
                                                style={{
                                                  color:
                                                    subItem?.itemFlag == "ON"
                                                      ? "green"
                                                      : "red",
                                                }}
                                                onChange={() => {
                                                  setPriceAmountOfItem(
                                                    subItem?.price
                                                  );
                                                  setMenuPlanList(
                                                    menuPlanList.map(
                                                      (items) => ({
                                                        ...items,
                                                        itemList:
                                                          items.itemList.map(
                                                            (object1) => {
                                                              return object1?.itemFlag ==
                                                                "ON"
                                                                ? {
                                                                    ...(object1[
                                                                      "itemFlag"
                                                                    ] = "OFF"),
                                                                  }
                                                                : {
                                                                    ...(object1[
                                                                      "itemFlag"
                                                                    ] = "ON"),
                                                                  };
                                                            }
                                                          ),
                                                      })
                                                    )
                                                  );
                                                  updatemenuAvailablity(
                                                    "foodItemUpdate",
                                                    mainItem,
                                                    subItem
                                                  );
                                                }}
                                                aria-label="checkedA"
                                              />{" "}
                                              <span
                                                style={{
                                                  color:
                                                    subItem?.itemFlag == "ON"
                                                      ? "green"
                                                      : "red",
                                                  fontSize: "x-small",
                                                  // marginLeft: "-8px"
                                                }}
                                              >
                                                {(dayOnOff === false
                                                  ? "day off"
                                                  : "") ||
                                                  (subItem?.itemFlag == "ON"
                                                    ? ""
                                                    : "Out of Stock")}
                                              </span>
                                            </div>
                                          )}
                                        </td>
                                        <td>
                                          {mainItem?.slotFlag == "ON" && (
                                            <>
                                              <Link
                                                to={"#"}
                                                onClick={() => {
                                                  SetUpdatemenuAvailablitymainItem(
                                                    mainItem
                                                  );
                                                  SetUpdatemenuAvailablitysubItem(
                                                    subItem
                                                  );
                                                  onRejectClose();
                                                  // updatemenuAvailablity("deleteItem", mainItem, subItem);
                                                }}
                                                className="ti-close fs-28 text-danger las la-times-circle"
                                              ></Link>

                                              <Link
                                                to={"#"}
                                                onClick={() => {
                                                  setEditmenuavailablity(true);
                                                  const newFormData = {
                                                    ...menuAvailablitMaster,
                                                  };
                                                  newFormData["menuId"] =
                                                    subItem?.menuId;
                                                  newFormData["mainMenuId"] =
                                                    subItem?.mainMenuId;
                                                  newFormData["subMenuId"] =
                                                    subItem?.subMenuId;
                                                  newFormData["uom"] =
                                                    subItem?.uom;
                                                  // newFormData["slotId"] = [mainItem?.slotId];
                                                  setMenuAvailablitMaster(
                                                    newFormData
                                                  );

                                                  const newFormData1 = {
                                                    ...selectedSlotTiming,
                                                  };
                                                  // newFormData1["label"] = mainItem?.slotName;
                                                  newFormData1["label"] = (
                                                    <div>
                                                      {" "}
                                                      {
                                                        mainItem?.slotName
                                                      } -{" "}
                                                      {mainItem?.slotStartTime}{" "}
                                                      - {mainItem?.slotEndTime}{" "}
                                                    </div>
                                                  );
                                                  newFormData1["value"] =
                                                    mainItem?.slotId;
                                                  // console.log(
                                                  //   "mainItem123",
                                                  //   newFormData1
                                                  // );
                                                  setSelectedSlotTiming([
                                                    newFormData1,
                                                  ]);
                                                  onAddUpdateUserModalClose();
                                                  // console.log("item?.slotId", subItem?.slotId);
                                                  setSelectedMenuItem({
                                                    label: subItem?.menuName,
                                                    value: subItem?.menuId,
                                                  });

                                                  setSelectedcategoryMaster({
                                                    label:
                                                      subItem?.mainMenuName,
                                                    value: subItem?.mainMenuId,
                                                  });

                                                  setPriceAmountOfItem(
                                                    subItem?.price
                                                  );
                                                  setQuanitytyOfItem(
                                                    subItem?.quantity
                                                  );

                                                  setSelectedsubcategoryMaster({
                                                    label: subItem?.subMenuName,
                                                    value: subItem?.subMenuId,
                                                  });

                                                  setSelectedslotmaster({
                                                    label: mainItem?.slotName,
                                                    value: mainItem?.slotId,
                                                  });
                                                }}
                                                className="ti-pencil fs-20 text-success"
                                              ></Link>
                                            </>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </Table>
                            </Card.Body>
                          </Card>
                        </Col>
                      );
                    })}

                  {menuPlanList && menuPlanList.length === 0 && (
                    <>
                      <br />
                      <h4 style={{ color: "green", marginLeft: "439px" }}>
                        No slots available for the day
                        <i
                          style={{ fontSize: "x-large", color: "red" }}
                          className="ti-alert"
                        ></i>
                      </h4>
                    </>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <br />

      {todaymenuPopup === false
        ? // <div
          //   style={{ paddingLeft: "800px" }}
          //   className="d-flex align-items-center flex-wrap"
          // >
          //   <Link
          //     to={"#"}
          //     onClick={accept}
          //     className="btn btn-success light border-success btn-rounded me-2  mb-2"
          //   >
          //     <i className="far fa-check-circle me-2"></i>
          //     {(activeStep === 0 && "Accept") ||
          //       (todaymenuPopup === false && activeStep === 1 && "Next") ||
          //       (todaymenuPopup === false && activeStep === 2 && "Delivery")}
          //   </Link>
          //   {todaymenuPopup === false && activeStep === 0 && (
          //     <Link
          //       to={"#"}
          //       onClick={(e) => OnRejectModal(e)}
          //       className="btn btn-danger light border-danger btn-rounded me-2 mb-2"
          //     >
          //       <i className="far fa-times-circle me-2"></i>Reject
          //     </Link>
          //   )}
          // </div>
          ""
        : ""}

      {
        <Modal
          isOpen={viewmoreslots}
          toggle={() => {
            setViewmoreslots(!viewmoreslots);
          }}
          size={"lg"}
          style={{ maxWidth: "600px" }}
          backdrop="static"
        >
          <ModalHeader>
            <div className="row">
              <div className="col-md-8"> Today Menu Details</div>
              <div className="col-md-4 text-right">
                {/* <i
                 onClick={() => {
                  handleGeneratePdf();
                }}
                  style={{
                    fontSize: "x-large",
                    color: "green",
                    marginRight: "16px"
                  }}
                  className="ti-printer"
                ></i> */}
                <i
                  onClick={() => {
                    setViewmoreslots(false);
                    setSelectedMenuType("today");
                  }}
                  style={{
                    fontSize: "x-large",
                    color: "green",
                    marginRight: "14px",
                  }}
                  className="ti-pencil"
                ></i>
                <i
                  onClick={() => {
                    // console.log("pdfDataTodaymenu", pdfDataTodaymenu);

                    // setViewmoreslots(!viewmoreslots);
                    // setSelectedMenuType("weekly");
                    setViewmoreslots(!viewmoreslots);
                    setSelectedMenuType(selectedMenuType || "");
                  }}
                  style={{ fontSize: "x-large", color: "red" }}
                  className="ti-close"
                ></i>
              </div>
            </div>
          </ModalHeader>

          <ModalBody>
            <div id="App" ref={reportTemplateRef}>
              <SlotPdf
                selectedDateName={selectedDateName}
                selectedDateFormat={selectedDateFormat}
                selectedViewMoreslotsDetails={selectedViewMoreslotsDetails}
              />
            </div>
            {/* <ReactPanZoom
              image={pdfDataTodaymenu}
            /> */}
          </ModalBody>

          {/* <ModalFooter>
            <Button
              variant="danger"
              onClick={() => {
                setViewmoreslots(!viewmoreslots);
                setSelectedMenuType(selectedMenuType || "");
              }}
            >
              Cancel
            </Button>
          </ModalFooter> */}
        </Modal>
      }

      <Modal
        isOpen={rejectModal}
        toggle={() => onRejectClose()}
        // size={"lg"}
        // style={{ maxWidth: "800px" }}
        backdrop="static"
      >
        <ModalHeader>
          Delete Confirmation - {updatemenuAvailablitysubItem?.menuName}{" "}
        </ModalHeader>
        <ModalBody>Are Sure want delete Menu item ?</ModalBody>
        <ModalFooter>
          <Button
            className="me-2"
            variant="success"
            onClick={() =>
              updatemenuAvailablity(
                "deleteItem",
                updatemenuAvailablitymainItem,
                updatemenuAvailablitysubItem
              )
            }
          >
            Submit
          </Button>
          <Button variant="danger" onClick={() => onRejectClose()}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      {/* menu list popup (today & tomorrow) */}
      <Modal
        isOpen={menulistpopup}
        toggle={() => onMenuClose()}
        // size={"lg"}
        style={{ maxWidth: "800px" }}
        backdrop="static"
      >
        <ModalHeader onClick={onMenuClose}>ADD ITEM </ModalHeader>
        <ModalBody>
          <div className="row">
            {/* <div className="col-sm-6 col-md-4 col-xl-4">
                            <FormGroup>
                                <Label for="itemname">
                                    Item Name<span class="text-danger">*</span>
                                </Label>
                                <Input
                                    type="text"
                                    name="itemname"
                                    id="itemname"
                                    placeholder="Item Name"
                                    maxLength="40"
                                    required
                                    autoComplete="off"
                                    onChange={(e) =>
                                        onChangeCommonpopupsetOutletvalue(
                                            "itemName",
                                            e.target.value.trimStart()
                                        )
                                    }
                                    value={menulistitem?.itemName}
                                />
                                <span style={{ color: "red" }}>{errors["itemName"]}</span>
                            </FormGroup>
                        </div> */}

            <div className="col-sm-3 col-md-3 col-xl-3 pop-up-tab">
              <FormGroup>
                <label as="a" variant="badge badge-rounded badge-danger">
                  Menu ID
                </label>
                <Select
                  options={specialmenulist}
                  value={selectedspecialMenu}
                  closeMenuOnSelect={false}
                  placeholder="choose"
                  autoComplete="off"
                  selected=""
                  onChange={(event) => {
                    //  console.log("event", event);
                    setSelectedSpecialMenu(event);
                    onChangeCommonpopupsetOutletvalue("itemName", event.label);
                    //  console.log("event.value", event);
                  }}
                />
                <span style={{ color: "red" }}>{errors["itemName"]}</span>
              </FormGroup>
            </div>

            <div className="col-sm-6 col-md-4 col-xl-4">
              <FormGroup>
                <Label for="itemprice">
                  Item price<span class="text-danger">*</span>
                </Label>
                <Input
                  type="number"
                  min="0"
                  name="itemprice"
                  id="itemprice"
                  placeholder="Item price"
                  // maxLength="4"
                  required
                  autoComplete="off"
                  onKeyDown={blockInvalidChar}
                  onChange={(e) => {
                    if (e.target.value && e.target.value.length > 4) {
                      return false;
                    } else {
                      onChangeCommonpopupsetOutletvalue(
                        "itemPrice",
                        e.target.value
                      );
                    }
                  }}
                  value={menulistitem?.itemPrice}
                />
                <span style={{ color: "red" }}>{errors["itemPrice"]}</span>
              </FormGroup>
            </div>

            <div class="col-sm-6 col-md-4 col-xl-4">
              <label as="a" variant="badge badge-rounded badge-danger">
                Unit of Measure
              </label>
              <Select
                options={uomcategory}
                search
                placeholder="Uom"
                value={selUom}
                autoComplete="off"
                onChange={(event) => {
                  setSelUom({ label: event.label, value: event.value });
                  onChangeCommonpopupsetOutletvalue("uom", event);
                }}
              />
            </div>

            <div className="col-sm-6 col-md-4 col-xl-4">
              <FormGroup>
                <Label for="itemfam">
                  Item Tag<span class="text-danger">*</span>
                </Label>
                <TagsInput
                  value={selected}
                  onChange={(e) => {
                    onChangeCommonpopupsetOutletvalue("itemTag", e);
                  }}
                  placeHolder="Item Tag"
                />
                {/*  <Input
                  type="text"
                  name="itemfam"
                   id="itemqty"
                   placeholder="Item Family"
                  maxLength="40"
                  required
                  autoComplete="off"
                  onChange={(e) =>
                    onChangeCommonpopupsetOutletvalue("itemTag", e.target.value)
                  }
                  value={menulistitem?.itemTag}
                /> */}
                <span style={{ color: "red" }}>{errors["itemTag"]}</span>
              </FormGroup>
            </div>

            <div className="col-sm-6 col-md-4 col-xl-4">
              <Label for="veg">Item Type</Label>
              <FormGroup>
                <Input
                  type="radio"
                  name="veg"
                  id="veg"
                  checked={menulistitem?.itemType}
                  style={{
                    backgroundColor: menulistitem?.itemType ? "green" : "white",
                  }}
                  onChange={(e) => {
                    onChangeCommonpopup("itemType", true);
                  }}
                />
                <Label className="ml-5" for="veg">
                  Veg
                </Label>
                <img className="ml-5" src={food9} width="5%" height="5%"></img>{" "}
                <br />
                {foodTypeFromOutlet == "veg,nong-veg" && (
                  <>
                    <Input
                      type="radio"
                      name="veg"
                      id="nonveg"
                      checked={!menulistitem?.itemType}
                      style={{
                        backgroundColor: !menulistitem?.itemType
                          ? "green"
                          : "white",
                      }}
                      onChange={(e) => onChangeCommonpopup("itemType", false)}
                    />
                    <Label className="ml-5" for="nonveg">
                      Non-Veg
                    </Label>
                    <img
                      className="ml-5"
                      src={food10}
                      width="5%"
                      height="15%"
                    ></img>
                  </>
                )}
              </FormGroup>
            </div>

            {!isView ? (
              <div className="col-sm-6 col-md-4 col-xl-4">
                <FormGroup>
                  <Label for="itemfoodimg">
                    Item Food Image<span class="text-danger">*</span>
                  </Label>
                  <br />
                  <Input
                    type="file"
                    onChange={(e) => onChangeCommonpopup("itemFoodImage", e)}
                  />
                </FormGroup>
              </div>
            ) : (
              <div className="col-sm-6 col-md-4 col-xl-4">
                <FormGroup>
                  <Label for="itemfoodimg">
                    Item Food Image<span class="text-danger">*</span>
                  </Label>
                  <br />
                  <Input
                    type="file"
                    onChange={(e) => onChangeCommonpopup("itemFoodImage", e)}
                  />
                </FormGroup>
                <br />
                <div>
                  <img
                    src={menulistitem.itemImagePath}
                    style={{
                      width: "50px",
                      height: "50px",
                      display: "block",
                      marginLeft: "50px",
                    }}
                  ></img>
                </div>
              </div>
            )}

            <div className="col-sm-6 col-md-8 col-xl-8">
              <FormGroup>
                <Label for="itemqty">
                  Item Description<span class="text-danger">*</span>
                </Label>
                <Input
                  type="textarea"
                  name="itemqty"
                  id="itemqty"
                  placeholder="Enter Item description"
                  maxLength="35"
                  required
                  autoComplete="off"
                  onChange={(e) =>
                    onChangeCommonpopupsetOutletvalue(
                      "itemDesc",
                      e.target.value.trimStart()
                    )
                  }
                  value={menulistitem?.itemDesc}
                />
                <span style={{ color: "red" }}>{errors["itemDesc"]}</span>
              </FormGroup>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            disabled={menulistitem.itemFoodImage == ""}
            /*  className={!formIsValid ? "btn-disabled" : "btn-primary"} */
            onClick={() => {
              submitFoodItemApi();
            }}
          >
            Submit
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              setMenulistpopup(false);
              setErrors({});
              setSelecteduomMaster({});
              setSelected([]);
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

     
    </>
  );
};
export default OutletMenuPlanner;
